/*! License details at fancyapps.com/license */
(function(e, t) {
    typeof exports == `object` && typeof module < `u` ? t(exports) : typeof define == `function` && define.amd ? define([`exports`], t) : (e = typeof globalThis < `u` ? globalThis : e || self, t(e.window = e.window || {}))
})(this, function(e) {
    Object.defineProperty(e, Symbol.toStringTag, {
        value: `Module`
    });
    let t = e => typeof e == `object` && !!e && e.constructor === Object && Object.prototype.toString.call(e) === `[object Object]`,
        n = e => typeof e == `string`,
        r = e => e && e !== null && e instanceof Element && `nodeType` in e,
        i = function(e) {
            var t = new DOMParser().parseFromString(e, `text/html`).body;
            if (t.childElementCount > 1) {
                for (var n = document.createElement(`div`); t.firstChild;) n.appendChild(t.firstChild);
                return n
            }
            let r = t.firstChild;
            if (r && !(r instanceof HTMLElement)) {
                var n = document.createElement(`div`);
                return n.appendChild(r), n
            }
            return r
        },
        a = function(e) {
            if (!(e && e instanceof Element && e.offsetParent)) return !1;
            let t = !1,
                n = !1;
            if (e.scrollWidth > e.clientWidth) {
                let n = window.getComputedStyle(e).overflowX,
                    r = n.indexOf(`hidden`) !== -1,
                    i = n.indexOf(`clip`) !== -1,
                    a = n.indexOf(`visible`) !== -1;
                t = !r && !i && !a
            }
            if (e.scrollHeight > e.clientHeight) {
                let t = window.getComputedStyle(e).overflowY,
                    r = t.indexOf(`hidden`) !== -1,
                    i = t.indexOf(`clip`) !== -1,
                    a = t.indexOf(`visible`) !== -1;
                n = !r && !i && !a
            }
            return t || n
        },
        o = function(e, t = void 0) {
            return !e || e === document.body || t && e === t ? null : a(e) ? e : o(e.parentElement, t)
        },
        s = (e = !0, t = `--f-scrollbar-compensate`, n = `--f-body-margin`, r = `hide-scrollbar`) => {
            let i = document,
                a = i.body,
                o = i.documentElement;
            if (e) {
                if (a.classList.contains(r)) return;
                let e = window.innerWidth - o.getBoundingClientRect().width;
                e < 0 && (e = 0), o.style.setProperty(t, `${e}px`);
                let i = parseFloat(window.getComputedStyle(a).marginRight);
                i && a.style.setProperty(n, `${i}px`), a.classList.add(r)
            } else a.classList.remove(r), a.style.setProperty(n, ``), i.documentElement.style.setProperty(t, ``)
        },
        c = (e, ...n) => {
            let r = n.length;
            for (let i = 0; i < r; i++) {
                let r = n[i] || {};
                Object.entries(r).forEach(([n, r]) => {
                    let i = Array.isArray(r) ? [] : {};
                    e[n] || Object.assign(e, {
                        [n]: i
                    }), t(r) ? Object.assign(e[n], c(e[n], r)) : Array.isArray(r) ? Object.assign(e, {
                        [n]: [...r]
                    }) : Object.assign(e, {
                        [n]: r
                    })
                })
            }
            return e
        };

    function l() {
        return !!(typeof window < `u` && window.document && window.document.createElement)
    }
    let u = function(e = 0, t = 0, n = 0) {
            return Math.max(Math.min(t, n), e)
        },
        d = function(e = 0, t = 0, n = 0, r = 0, i = 0, a = !1) {
            let o = (e - t) / (n - t) * (i - r) + r;
            return a ? r < i ? u(r, o, i) : u(i, o, r) : o
        },
        f = (e, t = ``) => {
            e && e.classList && t.split(` `).forEach(t => {
                t && e.classList.add(t)
            })
        },
        p = (e, t = ``) => {
            e && e.classList && t.split(` `).forEach(t => {
                t && e.classList.remove(t)
            })
        },
        m = (e, t = ``, n) => {
            e && e.classList && t.split(` `).forEach(t => {
                t && e.classList.toggle(t, n || !1)
            })
        };

    function h(e) {
        return t(e) || Array.isArray(e)
    }

    function g(e, t) {
        let n = Object.keys(e),
            r = Object.keys(t);
        return n.length === r.length ? n.every(n => {
            let r = e[n],
                i = t[n];
            return typeof r == `function` ? `${r}` == `${i}` : !h(r) || !h(i) ? r === i : g(r, i)
        }) : !1
    }
    let _ = function(e) {
            for (let t of x) t.getState() === v.Running && t.tick(C ? e - C : 0);
            C = e, S = window.requestAnimationFrame(_)
        },
        v = function(e) {
            return e[e.Initializing = 0] = `Initializing`, e[e.Running = 1] = `Running`, e[e.Paused = 2] = `Paused`, e[e.Completed = 3] = `Completed`, e[e.Destroyed = 4] = `Destroyed`, e
        }({});
    var y = function(e) {
        return e[e.Spring = 0] = `Spring`, e[e.Ease = 1] = `Ease`, e
    }(y || {});
    let b = function(e) {
            return e[e.Loop = 0] = `Loop`, e[e.Reverse = 1] = `Reverse`, e
        }({}),
        x = new Set,
        S = null,
        C = 0;

    function w() {
        let e = v.Initializing,
            t = y.Ease,
            n = 0,
            r = 0,
            i = w.Easings.Linear,
            a = 500,
            o = 0,
            s = 0,
            c = 0,
            l = 0,
            d = 1 / 0,
            f = .01,
            p = .01,
            m = !1,
            h = {},
            C = null,
            T = {},
            E = {},
            D = {},
            O = 0,
            k = 0,
            A = b.Loop,
            j = w.Easings.Linear,
            M = new Map;

        function N(e, t) {
            M.set(e, [...M.get(e) || [], t])
        }

        function ee(e, t) {
            M.has(e) && M.set(e, M.get(e).filter(e => e !== t))
        }

        function P(e, ...t) {
            for (let n of M.get(e) || []) n(...t)
        }

        function F(e) {
            return r = 0, e ? C = setTimeout(() => {
                I()
            }, e) : I(), B
        }

        function I() {
            e = v.Running, P(`start`, T, E)
        }

        function L() {
            return C &&= (clearTimeout(C), null), e === v.Running && (e = v.Paused, P(`pause`, T)), B
        }

        function R(n) {
            n > 50 && (n = 50), r += n;
            let _ = 0,
                x = !1;
            if (e !== v.Running) return B;
            if (t === y.Ease) {
                _ = u(0, r / a, 1), x = _ === 1;
                let e = A === b.Reverse ? j : i;
                for (let t in T) T[t] = h[t] + (E[t] - h[t]) * e(_)
            }
            if (t === y.Spring) {
                let e = n * .001,
                    t = 0;
                for (let n in T) {
                    let r = E[n],
                        i = T[n];
                    if (!(typeof r == `number` && !isNaN(r)) || !(typeof i == `number` && !isNaN(i))) continue;
                    if (Math.abs(r - i) <= p) {
                        T[n] = r, D[n] = 0;
                        continue
                    }
                    D[n] || (typeof o == `object` && typeof o[n] == `number` ? D[n] = o[n] : typeof o == `number` ? D[n] = o : D[n] = 0);
                    let a = D[n];
                    a = u(Math.abs(d) * -1, a, Math.abs(d));
                    let h = a * s * l,
                        g = Math.abs(r - i) * c,
                        _ = ((i > r ? -1 : 1) * g - h) / s;
                    a += _ * e, i += a * e;
                    let v = T[n] > r ? i < r : i > r,
                        y = Math.abs(a) < f && Math.abs(r - i) <= p;
                    m && v && (y = !0), y ? (i = r, a = 0) : t++, T[n] = i, D[n] = a
                }
                x = !t
            }
            let S = {
                ...E
            };
            return P(`step`, T, h, E, _), x && e === v.Running && g(E, S) && (e = v.Completed, z()), B
        }

        function z() {
            if (e = v.Completed, D = {}, P(`end`, T), e === v.Completed)
                if (n < O) {
                    if (n++, A === b.Reverse) {
                        let e = {
                            ...h
                        };
                        h = {
                            ...E
                        }, E = e
                    }
                    F(k)
                } else n = 0;
            return B
        }
        let B = {
            getState: function() {
                return e
            },
            easing: function(e) {
                return i = e, t = y.Ease, D = {}, B
            },
            duration: function(e) {
                return a = e, B
            },
            spring: function(e = {}) {
                t = y.Spring;
                let {
                    velocity: n,
                    mass: r,
                    tension: i,
                    friction: a,
                    restDelta: u,
                    restSpeed: h,
                    maxSpeed: g,
                    clamp: _
                } = {
                    velocity: 0,
                    mass: 1,
                    tension: 170,
                    friction: 26,
                    restDelta: .1,
                    restSpeed: .1,
                    maxSpeed: 1 / 0,
                    clamp: !0,
                    ...e
                };
                return o = n, s = r, c = i, l = a, p = u, f = h, d = g, m = _, D = {}, B
            },
            isRunning: function() {
                return e === v.Running
            },
            isSpring: function() {
                return t === y.Spring
            },
            from: function(e) {
                return T = {
                    ...e
                }, B
            },
            to: function(e) {
                return E = e, B
            },
            repeat: function(e, t = 0, n = b.Loop, r) {
                return O = e, k = t, A = n, j = r || i, B
            },
            on: function(e, t) {
                return N(e, t), B
            },
            off: function(e, t) {
                return ee(e, t), B
            },
            start: function(t) {
                return g(T, E) || (e = v.Initializing, h = {
                    ...T
                }, x.add(this), S ||= window.requestAnimationFrame(_), F(t)), B
            },
            pause: L,
            end: z,
            tick: R,
            getStartValues: function() {
                return h
            },
            getCurrentValues: function() {
                return T
            },
            getCurrentVelocities: function() {
                return D
            },
            getEndValues: function() {
                return E
            },
            destroy: function() {
                e = v.Destroyed, C &&= (clearTimeout(C), null), h = T = E = {}, x.delete(this)
            }
        };
        return B
    }
    w.destroy = () => {
        for (let e of x) e.destroy();
        S &&= (cancelAnimationFrame(S), null)
    }, w.Easings = {
        Linear: function(e) {
            return e
        },
        EaseIn: function(e) {
            return e === 0 ? 0 : 2 ** (10 * e - 10)
        },
        EaseOut: function(e) {
            return e === 1 ? 1 : 1 - 2 ** (-10 * e)
        },
        EaseInOut: function(e) {
            return e === 0 ? 0 : e === 1 ? 1 : e < .5 ? 2 ** (20 * e - 10) / 2 : (2 - 2 ** (-20 * e + 10)) / 2
        }
    };

    function T(e) {
        return typeof TouchEvent < `u` && e instanceof TouchEvent
    }

    function E(e, t) {
        let n = [],
            r = T(e) ? e[t] : e instanceof MouseEvent && (t === `changedTouches` || e.type !== `mouseup`) ? [e] : [];
        for (let e of r) n.push({
            x: e.clientX,
            y: e.clientY,
            ts: Date.now()
        });
        return n
    }

    function D(e) {
        return E(e, `touches`)
    }

    function O(e) {
        return E(e, `targetTouches`)
    }

    function k(e) {
        return E(e, `changedTouches`)
    }

    function A(e) {
        let t = e[0],
            n = e[1] || t;
        return {
            x: (t.x + n.x) / 2,
            y: (t.y + n.y) / 2,
            ts: n.ts
        }
    }

    function j(e) {
        let t = e[0],
            n = e[1] || e[0];
        return t && n ? Math.sqrt((n.x - t.x) * (n.x - t.x) + (n.y - t.y) * (n.y - t.y)) * -1 : 0
    }
    let M = e => {
            e.cancelable && e.preventDefault()
        },
        N = {
            passive: !1
        },
        ee = {
            panThreshold: 5,
            swipeThreshold: 3,
            ignore: [`textarea`, `input`, `select`, `[contenteditable]`, `[data-selectable]`, `[data-draggable]`]
        },
        P = !1,
        F = !0,
        I = (e, t) => {
            let n = {
                    ...ee,
                    ...t
                },
                r, i = [],
                a = [],
                o = [],
                s = !1,
                c = !1,
                l = !1,
                u = !1,
                d = 0,
                f = 0,
                p, m = 0,
                h = 0,
                g = 0,
                _ = 0,
                v = 0,
                y = 0,
                b = 0,
                x, S = [],
                C, w, T = new Map;

            function E(e, t) {
                T.set(e, [...T.get(e) || [], t])
            }

            function I(e) {
                let t = j(a),
                    n = j(o),
                    l = t && n ? t / n : 0,
                    u = {
                        srcEvent: r,
                        isPanRecognized: s,
                        isSwipeRecognized: c,
                        firstTouch: i,
                        previousTouch: o,
                        currentTouch: a,
                        deltaX: m,
                        deltaY: h,
                        offsetX: g,
                        offsetY: _,
                        velocityX: v,
                        velocityY: y,
                        velocity: Math.abs(v) > Math.abs(y) ? v : y,
                        angle: b,
                        axis: x,
                        scale: l,
                        center: p
                    };
                for (let t of T.get(e) || []) t(u)
            }

            function L(e) {
                let t = e.target,
                    r = e.composedPath()[0],
                    i = n.ignore.join(`,`),
                    a = e => e && e instanceof HTMLElement && (e.matches(i) || e.closest(i));
                if (a(t) || a(r)) return !1
            }

            function R(e) {
                let t = Date.now();
                if (S = S.filter(e => !e.ts || e.ts > t - 100), e && S.push(e), v = 0, y = 0, S.length > 3) {
                    let e = S[0],
                        t = S[S.length - 1];
                    if (e && t) {
                        let n = t.x - e.x,
                            r = t.y - e.y,
                            i = e.ts && t.ts ? t.ts - e.ts : 0;
                        i > 0 && (v = Math.abs(n) > 3 ? n / (i / 30) : 0, y = Math.abs(r) > 3 ? r / (i / 30) : 0)
                    }
                }
            }

            function z(e) {
                if (L(e) === !1) return;
                if (typeof MouseEvent < `u` && e instanceof MouseEvent) {
                    if (P) return
                } else P = !0;
                if (typeof MouseEvent < `u` && e instanceof MouseEvent) {
                    if (!e.buttons || e.button !== 0) return;
                    M(e)
                }
                e instanceof MouseEvent && (window.addEventListener(`mousemove`, B), window.addEventListener(`mouseup`, V)), window.addEventListener(`blur`, H), r = e, a = O(e), i = [...a], o = [], f = a.length, p = A(a), f === 1 && (s = !1, c = !1, l = !1), f && R(A(a));
                let t = Date.now(),
                    n = t - (d || t);
                u = n > 0 && n <= 250 && f === 1, d = t, clearTimeout(C), I(`start`)
            }

            function B(e) {
                if (!i.length || e.defaultPrevented || L(e) === !1) return;
                r = e, o = [...a], a = D(e);
                let t = A(o),
                    c = A(D(e));
                if (R(c), f = a.length, p = c, o.length === a.length ? (m = c.x - t.x, h = c.y - t.y) : (m = 0, h = 0), i.length) {
                    let e = A(i);
                    g = c.x - e.x, _ = c.y - e.y
                }
                if (a.length > 1) {
                    let e = j(a),
                        t = j(o);
                    Math.abs(e - t) >= .1 && (l = !0, I(`pinch`))
                }
                s || (s = Math.abs(g) >= n.panThreshold || Math.abs(_) >= n.panThreshold, s && (F = !1, clearTimeout(w), w = void 0, b = Math.abs(Math.atan2(_, g) * 180 / Math.PI), x = b > 45 && b < 135 ? `y` : `x`, i = [...a], o = [...a], g = 0, _ = 0, m = 0, h = 0, window.getSelection()?.removeAllRanges(), I(`panstart`))), s && (m || h) && I(`pan`), I(`move`)
            }

            function V(e) {
                if (r = e, !i.length) return;
                let t = O(e),
                    d = k(e);
                if (f = t.length, p = A(d), d.length && R(A(d)), o = [...a], a = [...t], i = [...t], f > 0) I(`end`), s = !1, c = !1, S = [];
                else {
                    let e = n.swipeThreshold;
                    (Math.abs(v) > e || Math.abs(y) > e) && (c = !0), s && I(`panend`), c && I(`swipe`), !s && !c && !l && (I(`tap`), u ? I(`doubleTap`) : C = setTimeout(function() {
                        I(`singleTap`)
                    }, 250)), I(`end`), te()
                }
            }

            function H() {
                clearTimeout(C), te(), s && I(`panend`), I(`end`)
            }

            function te() {
                P = !1, s = !1, c = !1, u = !1, f = 0, S = [], a = [], o = [], i = [], m = 0, h = 0, g = 0, _ = 0, v = 0, y = 0, b = 0, x = void 0, window.removeEventListener(`mousemove`, B), window.removeEventListener(`mouseup`, V), window.removeEventListener(`blur`, H), !F && !w && (w = setTimeout(() => {
                    F = !0, w = void 0
                }, 100))
            }

            function U(e) {
                let t = e.target;
                P = !1, !(!t || e.defaultPrevented) && (F || (M(e), e.stopPropagation()))
            }

            function W() {
                return e && (e.addEventListener(`click`, U, N), e.addEventListener(`mousedown`, z, N), e.addEventListener(`touchstart`, z, N), e.addEventListener(`touchmove`, B, N), e.addEventListener(`touchend`, V), e.addEventListener(`touchcancel`, V)), ne
            }
            let ne = {
                init: W,
                on: function(e, t) {
                    return E(e, t), ne
                },
                off: function(e, t) {
                    return T.has(e) && T.set(e, T.get(e).filter(e => e !== t)), ne
                },
                isPointerDown: () => f > 0,
                destroy: function() {
                    clearTimeout(C), clearTimeout(w), w = void 0, e && (e.removeEventListener(`click`, U, N), e.removeEventListener(`mousedown`, z, N), e.removeEventListener(`touchstart`, z, N), e.removeEventListener(`touchmove`, B, N), e.removeEventListener(`touchend`, V), e.removeEventListener(`touchcancel`, V)), e = null, te()
                }
            };
            return ne
        };
    I.isClickAllowed = () => F;
    let L = {
            IMAGE_ERROR: `This image couldn't be loaded. <br /> Please try again later.`,
            MOVE_UP: `Move up`,
            MOVE_DOWN: `Move down`,
            MOVE_LEFT: `Move left`,
            MOVE_RIGHT: `Move right`,
            ZOOM_IN: `Zoom in`,
            ZOOM_OUT: `Zoom out`,
            TOGGLE_FULL: `Toggle zoom level`,
            TOGGLE_1TO1: `Toggle zoom level`,
            ITERATE_ZOOM: `Toggle zoom level`,
            ROTATE_CCW: `Rotate counterclockwise`,
            ROTATE_CW: `Rotate clockwise`,
            FLIP_X: `Flip horizontally`,
            FLIP_Y: `Flip vertically`,
            RESET: `Reset`,
            TOGGLE_FS: `Toggle fullscreen`
        },
        R = 1e4,
        z = e => {
            e.cancelable && e.preventDefault()
        },
        B = (e, t = R) => (e = parseFloat(e + ``) || 0, Math.round((e + 2 ** -52) * t) / t),
        V = e => e instanceof HTMLImageElement,
        H = function(e) {
            return e.Reset = `reset`, e.Zoom = `zoom`, e.ZoomIn = `zoomIn`, e.ZoomOut = `zoomOut`, e.ZoomTo = `zoomTo`, e.ToggleCover = `toggleCover`, e.ToggleFull = `toggleFull`, e.ToggleMax = `toggleMax`, e.IterateZoom = `iterateZoom`, e.Pan = `pan`, e.Swipe = `swipe`, e.Move = `move`, e.MoveLeft = `moveLeft`, e.MoveRight = `moveRight`, e.MoveUp = `moveUp`, e.MoveDown = `moveDown`, e.RotateCCW = `rotateCCW`, e.RotateCW = `rotateCW`, e.FlipX = `flipX`, e.FlipY = `flipY`, e.ToggleFS = `toggleFS`, e
        }({}),
        te = function(e) {
            return e.Cover = `cover`, e.Full = `full`, e.Max = `max`, e
        }({}),
        U = {
            x: 0,
            y: 0,
            scale: 1,
            angle: 0,
            flipX: 1,
            flipY: 1
        },
        W = function(e) {
            return e[e.Init = 0] = `Init`, e[e.Loading = 1] = `Loading`, e[e.Error = 2] = `Error`, e[e.Ready = 3] = `Ready`, e[e.Destroyed = 4] = `Destroyed`, e
        }({}),
        ne = {
            bounds: !0,
            classes: {
                container: `f-panzoom`,
                wrapper: `f-panzoom__wrapper`,
                content: `f-panzoom__content`,
                viewport: `f-panzoom__viewport`
            },
            clickAction: H.ToggleFull,
            dblClickAction: !1,
            gestures: {},
            height: `auto`,
            l10n: L,
            maxScale: 4,
            minScale: 1,
            mouseMoveFactor: 1,
            panMode: `drag`,
            protected: !1,
            singleClickAction: !1,
            spinnerTpl: `<div class="f-spinner"></div>`,
            wheelAction: H.Zoom,
            width: `auto`
        },
        re = 0,
        ie, G = 0,
        ae = 0,
        oe = (e, t = {}, a = {}) => {
            let s = W.Init,
                c = {
                    ...ne,
                    ...t
                },
                l = {},
                d, h, _, v, y = {
                    ...U
                },
                b = {
                    ...U
                },
                x, S, C, T, E = [];

            function D(e) {
                let t = c[e];
                return t && typeof t == `function` ? t(Ze) : t
            }

            function O(e, t = []) {
                let n = D(`l10n`) || {};
                e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t) => n[t] || e);
                for (let n = 0; n < t.length; n++) e = e.split(t[n][0]).join(t[n][1]);
                return e = e.replace(/\{\{(.*?)\}\}/g, (e, t) => t), e
            }

            function j() {
                return e && e.parentElement && d && s === W.Ready
            }
            let M = new Map;

            function N(e, t) {
                for (let n of e instanceof Array ? e : [e]) M.set(n, [...M.get(n) || [], t]);
                return Ze
            }

            function ee(e, t) {
                for (let n of e instanceof Array ? e : [e]) M.has(n) && M.set(n, M.get(n).filter(e => e !== t));
                return Ze
            }

            function P(e, ...t) {
                let n = [...M.get(e) || []];
                c.on && n.push(c.on[e]);
                for (let e of n) e && typeof e == `function` && e(Ze, ...t);
                e !== `*` && P(`*`, e, ...t)
            }

            function F() {
                return s = W.Init, P(`init`), L(), te(), oe(), se(), Ze
            }

            function L() {
                for (let [e, t] of Object.entries({
                        ...a,
                        ...c.plugins || {}
                    }))
                    if (e && !l[e] && t instanceof Function) {
                        let n = t();
                        n.init(Ze), l[e] = n
                    } P(`initPlugins`)
            }

            function te() {
                let t = {
                        ...ne.classes,
                        ...D(`classes`)
                    },
                    n = t.content?.split(` `).shift(),
                    r = t.wrapper?.split(` `).shift(),
                    i = t.viewport?.split(` `).shift();
                if (!(!n || !r || !i) && e && (f(e, t.container), h = e.querySelector(`.${n}:not(.is-clone)`), h)) {
                    if (h.setAttribute(`draggable`, `false`), d = e.querySelector(`.${r}`), d || (d = document.createElement(`div`), f(d, t.wrapper), h.insertAdjacentElement(`beforebegin`, d), d.insertAdjacentElement(`afterbegin`, h)), v = e.querySelector(`.${i}`), v || (v = document.createElement(`div`), f(v, t.viewport), d.insertAdjacentElement(`beforeend`, v)), v.contains(h) || v.insertAdjacentElement(`afterbegin`, h), _ = e.querySelector(`.${n}.is-clone`), _ || (_ = h.cloneNode(!0), _.removeAttribute(`id`), f(_, `is-clone`), d.insertAdjacentElement(`afterbegin`, _)), h instanceof HTMLPictureElement && (h = h.querySelector(`img`)), _ instanceof HTMLPictureElement && (_ = _.querySelector(`img`)), v instanceof HTMLPictureElement && (v = v.querySelector(`img`)), v && (v.style.visibility = `hidden`, D(`protected`))) {
                        v.addEventListener(`contextmenu`, e => {
                            z(e)
                        });
                        let e = document.createElement(`div`);
                        f(e, `f-panzoom__protected`), v.appendChild(e)
                    }
                    P(`initLayout`)
                }
            }

            function oe() {
                if (e && d && !C) {
                    let e = null;
                    C = new ResizeObserver(() => {
                        j() && (e ||= requestAnimationFrame(() => {
                            j() && (Ae(), ke(), P(`refresh`)), e = null
                        }))
                    }), C.observe(d), E.push(() => {
                        C?.disconnect(), C = void 0, e &&= (cancelAnimationFrame(e), null)
                    })
                }
            }

            function se() {
                if (!e || !h) return;
                if (!(V(h) && V(_))) {
                    ge();
                    return
                }
                let t = () => {
                    h && V(h) && h.decode().then(() => {
                        ge()
                    }).catch(() => {
                        ge()
                    })
                };
                if (s = W.Loading, e.classList.add(`is-loading`), P(`loading`), _.src && _.complete) {
                    t();
                    return
                }
                me(), _.addEventListener(`load`, t, !1), _.addEventListener(`error`, t, !1), E.push(() => {
                    _?.removeEventListener(`load`, t, !1), _?.removeEventListener(`error`, t, !1)
                })
            }

            function K() {
                S = w().on(`start`, (e, t) => {
                    t.angle !== void 0 && (t.angle = Math.round(t.angle / 90) * 90), t.flipX !== void 0 && (t.flipX = t.flipX > 0 ? 1 : -1), t.flipY !== void 0 && (t.flipY = t.flipY > 0 ? 1 : -1), b = {
                        ...U,
                        ...t
                    }, Ae(), P(`animationStart`)
                }).on(`pause`, e => {
                    b = {
                        ...U,
                        ...e
                    }
                }).on(`step`, e => {
                    if (!j()) {
                        S?.end();
                        return
                    }
                    if (y = {
                            ...U,
                            ...e
                        }, xe() || !D(`bounds`) || X() || b.scale > y.scale || b.scale < q()) {
                        Y();
                        return
                    }
                    let t = Oe(b.scale),
                        n = !1,
                        r = !1,
                        i = !1,
                        a = !1;
                    y.x < t.x[0] && (n = !0), y.x > t.x[1] && (r = !0), y.y < t.y[0] && (a = !0), y.y > t.y[1] && (i = !0);
                    let o = !1,
                        s = !1,
                        c = !1,
                        l = !1;
                    b.x < t.x[0] && (o = !0), b.x > t.x[1] && (s = !0), b.y < t.y[0] && (l = !0), b.y > t.y[1] && (c = !0);
                    let d = !1;
                    (r && s || n && o) && (b.x = u(t.x[0], b.x, t.x[1]), d = !0), (i && c || a && l) && (b.y = u(t.y[0], b.y, t.y[1]), d = !0), d && S && S.spring({
                        tension: 94,
                        friction: 17,
                        maxSpeed: 555 * b.scale,
                        restDelta: .1,
                        restSpeed: .1,
                        velocity: S.getCurrentVelocities()
                    }).from(y).to(b).start(), Y()
                }).on(`end`, () => {
                    x?.isPointerDown() || ke(), S?.isRunning() || (Ae(), P(`animationEnd`))
                })
            }

            function ce() {
                let e = D(`gestures`);
                if (!e || !v || !h) return;
                let t = !1;
                x = I(v, e).on(`start`, e => {
                    if (!D(`gestures`) || !S || !j() || xe()) return;
                    let n = e.srcEvent;
                    (y.scale > 1 || Ke(y.angle) || e.currentTouch.length > 1) && (n?.stopPropagation(), S.pause(), t = !0), e.currentTouch.length === 1 && P(`touchStart`)
                }).on(`move`, e => {
                    t && (b.scale !== 1 || Ke(b.angle) || e.currentTouch.length > 1) && (z(e.srcEvent), e.srcEvent?.stopPropagation())
                }).on(`pan`, e => {
                    if (!t) return;
                    let n = e.srcEvent;
                    (b.scale !== 1 || Ke(b.angle) || e.currentTouch.length > 1) && (z(n), J(H.Pan, e))
                }).on(`swipe`, e => {
                    t && (b.scale > 1 || Ke(b.angle)) && J(H.Swipe, e)
                }).on(`tap`, e => {
                    P(`click`, e)
                }).on(`singleTap`, e => {
                    P(`singleClick`, e)
                }).on(`doubleTap`, e => {
                    P(`dblClick`, e)
                }).on(`pinch`, e => {
                    t && (e.scale > q() ? J(H.ZoomIn, e) : e.scale < q() ? J(H.ZoomOut, e) : J(H.Pan, e))
                }).on(`end`, e => {
                    t && (e.currentTouch.length ? (e.srcEvent.stopPropagation(), z(e.srcEvent), S?.end()) : (t = !1, Ae(), ke(), P(`touchEnd`)))
                }).init()
            }

            function le() {
                v && (v.addEventListener(`wheel`, ue, {
                    passive: !1
                }), E.push(() => {
                    v?.removeEventListener(`wheel`, ue, {
                        passive: !1
                    })
                }))
            }

            function ue(e) {
                if (!j()) return;
                let t = e.target;
                if (o(t)) return;
                let n = Date.now(),
                    r = u(-1, [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(function(e, t) {
                        return Math.abs(t) > Math.abs(e) ? t : e
                    }), 1);
                P(`wheel`, e, r);
                let i = D(`wheelAction`);
                if (!i || e.defaultPrevented) return;
                let a = b.scale,
                    s = a * (r > 0 ? 1.5 : .5);
                if (i === H.Zoom) {
                    let t = Math.abs(e.deltaY) < 100 && Math.abs(e.deltaX) < 100 ? 200 : 45;
                    if (n - G < t) {
                        z(e);
                        return
                    }
                    G = n;
                    let i = we(),
                        o = De();
                    if (B(s) < B(i) && B(a) <= B(i) ? (ae += Math.abs(r), s = i) : B(s) > B(o) && B(a) >= B(o) ? (ae += Math.abs(r), s = o) : (ae = 0, s = u(i, s, o)), ae > 7) return
                }
                switch (z(e), i) {
                    case H.Pan:
                        J(i, {
                            srcEvent: e,
                            deltaX: -e.deltaX * 2,
                            deltaY: -e.deltaY * 2
                        });
                        break;
                    case H.Zoom:
                        J(H.ZoomTo, {
                            srcEvent: e,
                            scale: s,
                            center: {
                                x: e.clientX,
                                y: e.clientY
                            }
                        });
                        break;
                    default:
                        J(i, {
                            srcEvent: e
                        })
                }
            }

            function de(t) {
                let n = t.composedPath()[0];
                if (!I.isClickAllowed() || !r(n) || t.defaultPrevented || !e?.contains(n) || n.hasAttribute(`disabled`) || n.hasAttribute(`aria-disabled`) || n.hasAttribute(`data-carousel-go-prev`) || n.hasAttribute(`data-carousel-go-next`)) return;
                let i = n.closest(`[data-panzoom-action]`),
                    a = i?.dataset?.panzoomAction,
                    o = i?.dataset?.panzoomValue || ``;
                if (a) {
                    switch (z(t), a) {
                        case H.ZoomTo:
                        case H.ZoomIn:
                        case H.ZoomOut:
                            J(a, {
                                scale: parseFloat(o || ``) || void 0
                            });
                            break;
                        case H.MoveLeft:
                        case H.MoveRight:
                            J(a, {
                                deltaX: parseFloat(o || ``) || void 0
                            });
                            break;
                        case H.MoveUp:
                        case H.MoveDown:
                            J(a, {
                                deltaY: parseFloat(o || ``) || void 0
                            });
                            break;
                        case H.ToggleFS:
                            Ye();
                            break;
                        default:
                            J(a);
                            break
                    }
                    return
                }
                if (!d?.contains(n)) return;
                let s = {
                    srcEvent: t
                };
                if (J(D(`clickAction`), s), D(`dblClickAction`)) {
                    let e = Date.now(),
                        t = e - (re || e),
                        n = t > 0 && t <= 250;
                    re = e, n ? (ie &&= (clearTimeout(ie), void 0), J(D(`dblClickAction`), s)) : ie = setTimeout(() => {
                        J(D(`singleClickAction`), s)
                    }, 250)
                }
            }

            function fe(e) {
                if (T = e, !j() || !xe() || y.scale <= 1 || b.scale <= 1 || (d?.dataset.animationName || ``).indexOf(`zoom`) > -1) return;
                let t = Se(b.scale);
                if (!t) return;
                let {
                    x: n,
                    y: r
                } = t;
                J(H.Pan, {
                    deltaX: n - b.x,
                    deltaY: r - b.y
                })
            }

            function pe() {
                e?.addEventListener(`click`, de), document?.addEventListener(`mousemove`, fe), E.push(() => {
                    e?.removeEventListener(`click`, de), document?.removeEventListener(`mousemove`, fe)
                })
            }

            function me() {
                if (!e || e?.querySelector(`.f-spinner`)) return;
                let t = i(D(`spinnerTpl`));
                t && (t.classList.add(`f-spinner`), e.classList.add(`is-loading`), d?.insertAdjacentElement(`afterbegin`, t))
            }

            function he() {
                e && (p(e, `is-loading`), e.querySelector(`.f-spinner`)?.remove())
            }

            function ge() {
                if (!e || !h) return;
                if (he(), V(h) && !(h.complete && h.naturalWidth)) {
                    s = W.Error, d?.classList.add(`has-error`), P(`error`);
                    return
                }
                P(`loaded`);
                let {
                    width: t,
                    height: n
                } = ye();
                V(h) && (h.setAttribute(`width`, t + ``), h.setAttribute(`height`, n + ``)), d && (p(d, `has-error`), V(h) && (d.setAttribute(`width`, t + ``), d.setAttribute(`height`, n + ``), d.style.aspectRatio = `${t/n||``}`)), K(), ce(), le(), pe();
                let r = _e();
                y = {
                    ...r
                }, b = {
                    ...r
                }, s = W.Ready, Y(), Ae(), P(`ready`), requestAnimationFrame(() => {
                    s === W.Ready && (he(), v && (v.style.visibility = ``))
                })
            }

            function _e() {
                let e = {
                        ...D(`startPos`) || {}
                    },
                    t = e.scale,
                    n = 1;
                n = typeof t == `string` ? Ce(t) : typeof t == `number` ? t : q();
                let r = {
                        ...U,
                        ...e,
                        scale: n
                    },
                    i = xe() ? Se(n) : void 0;
                if (i) {
                    let {
                        x: e,
                        y: t
                    } = i;
                    r.x = e, r.y = t
                }
                return r
            }

            function ve() {
                let e = {
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0
                };
                if (d) {
                    let t = d.getBoundingClientRect();
                    Ke(b.angle) ? (e.top = t.top + t.height * .5 - t.width * .5, e.left = t.left + t.width * .5 - t.height * .5, e.width = t.height, e.height = t.width) : (e.top = t.top, e.left = t.left, e.width = t.width, e.height = t.height)
                }
                return e
            }

            function ye() {
                let e = D(`width`),
                    t = D(`height`);
                if (h && e === `auto`) {
                    let t = h.getAttribute(`width`);
                    e = t ? parseFloat(t + ``) : h.dataset.width === void 0 ? V(v) ? v.naturalWidth : V(h) ? h.naturalWidth : d?.getBoundingClientRect().width || 0 : parseFloat(h.dataset.width + ``)
                } else e = n(e) ? parseFloat(e) : e;
                if (h && t === `auto`) {
                    let e = h.getAttribute(`height`);
                    t = e ? parseFloat(e + ``) : h.dataset.height === void 0 ? V(v) ? v.naturalHeight : V(h) ? h.naturalHeight : d?.getBoundingClientRect().height || 0 : parseFloat(h.dataset.height + ``)
                } else t = n(t) ? parseFloat(t) : t;
                return {
                    width: e,
                    height: t
                }
            }

            function be() {
                let e = ve();
                return {
                    width: e.width,
                    height: e.height
                }
            }

            function xe() {
                return D(`panMode`) === `mousemove` && matchMedia(`(hover: hover)`).matches
            }

            function Se(e) {
                let t = T || D(`event`),
                    n = d?.getBoundingClientRect();
                if (!t || !n || e <= 1) return {
                    x: 0,
                    y: 0
                };
                let r = (t.clientX || 0) - n.left,
                    i = (t.clientY || 0) - n.top,
                    {
                        width: a,
                        height: o
                    } = be(),
                    s = Oe(e);
                if (e > 1) {
                    let t = D(`mouseMoveFactor`);
                    t > 1 && (e *= t)
                }
                let c = a * e,
                    l = o * e,
                    f = (c - a) * .5 - (c - a) * (r / a * 100 / 100),
                    p = (l - o) * .5 - (l - o) * (i / o * 100 / 100);
                return f = u(s.x[0], f, s.x[1]), p = u(s.y[0], p, s.y[1]), {
                    x: f,
                    y: p
                }
            }

            function Ce(t) {
                if (!t) return b.scale;
                if (!e) return 1;
                let n = e.getBoundingClientRect(),
                    r = ve(),
                    {
                        width: i,
                        height: a
                    } = ye(),
                    o = e => {
                        if (typeof e == `number`) return e;
                        switch (e) {
                            case `min`:
                                return 1;
                            case `base`:
                                return 1;
                            case `cover`:
                                return Math.max(n.height / r.height, n.width / r.width) || 1;
                            case `full`:
                            case `max`: {
                                let e = Ke(b.angle) ? a : i;
                                return e && r.width ? e / r.width : 1
                            }
                        }
                    },
                    s = D(`minScale`),
                    c = D(`maxScale`),
                    l = Math.min(o(`full`), o(s)),
                    d = typeof c == `number` ? o(`full`) * c : Math.min(o(`full`), o(c));
                switch (t) {
                    case `min`:
                        return l;
                    case `base`:
                        return u(l, 1, d);
                    case `cover`:
                        return o(`cover`);
                    case `full`:
                        return Math.min(d, o(`full`));
                    case `max`:
                        return d
                }
            }

            function we() {
                return Ce(`min`)
            }

            function q() {
                return Ce(`base`)
            }

            function Te() {
                return Ce(`cover`)
            }

            function Ee() {
                return Ce(`full`)
            }

            function De() {
                return Ce(`max`)
            }

            function Oe(t) {
                let n = {
                        x: [0, 0],
                        y: [0, 0]
                    },
                    r = e?.getBoundingClientRect();
                if (!r) return n;
                let i = ve(),
                    a = r.width,
                    o = r.height,
                    s = i.width,
                    c = i.height;
                t = t === void 0 ? b.scale : t;
                let l = t,
                    u = t;
                if (xe() && t > 1) {
                    let e = D(`mouseMoveFactor`);
                    e > 1 && (s * t > a + .01 && (l *= e), c * t > o + .01 && (u *= e))
                }
                if (s *= l, c *= u, s > a) {
                    n.x[0] = (a - s) * .5, n.x[1] = (s - a) * .5;
                    let e = (i.left - r.left) * .5,
                        t = (i.left + i.width - r.right) * .5;
                    n.x[0] -= e + t, n.x[1] -= e + t
                }
                if (c > o) {
                    n.y[0] = (o - c) * .5, n.y[1] = (c - o) * .5;
                    let e = (i.top - r.top) * .5,
                        t = (i.top + i.height - r.bottom) * .5;
                    n.y[0] -= e + t, n.y[1] -= e + t
                }
                return n
            }

            function ke() {
                if (!j() || !D(`bounds`) || !S) return;
                let e = we(),
                    t = De(),
                    n = u(e, b.scale, t);
                if (b.scale < e - .01 || b.scale > t + .01) {
                    J(H.ZoomTo, {
                        scale: n
                    });
                    return
                }
                if (S.isRunning() || X()) return;
                let r = Oe(n);
                b.x < r.x[0] || b.x > r.x[1] || b.y < r.y[0] || b.y > r.y[1] ? (b.x = u(r.x[0], b.x, r.x[1]), b.y = u(r.y[0], b.y, r.y[1]), S.spring({
                    tension: 170,
                    friction: 17,
                    restDelta: .001,
                    restSpeed: .001,
                    maxSpeed: 1 / 0,
                    velocity: S.getCurrentVelocities()
                }), S.from(y).to(b).start()) : Y()
            }

            function Ae(t) {
                if (!j()) return;
                let n = Ge(),
                    r = X(),
                    i = qe(),
                    a = Je(),
                    o = Be(),
                    s = Ve();
                m(d, `is-fullsize`, a), m(d, `is-expanded`, i), m(d, `is-dragging`, r), m(d, `can-drag`, n), m(d, `will-zoom-in`, o), m(d, `will-zoom-out`, s);
                let c = Ue(),
                    l = We(),
                    u = He(),
                    f = !j();
                for (let n of (t || e)?.querySelectorAll(`[data-panzoom-action]`) || []) {
                    let e = n.dataset.panzoomAction,
                        t = !1;
                    if (f) t = !0;
                    else switch (e) {
                        case H.ZoomIn:
                            c || (t = !0);
                            break;
                        case H.ZoomOut:
                            u || (t = !0);
                            break;
                        case H.ToggleFull: {
                            l || u || (t = !0);
                            let e = n.querySelector(`g`);
                            e && (e.style.display = a && !t ? `none` : ``);
                            break
                        }
                        case H.IterateZoom: {
                            c || u || (t = !0);
                            let e = n.querySelector(`g`);
                            e && (e.style.display = !c && !t ? `none` : ``);
                            break
                        }
                        case H.ToggleCover:
                        case H.ToggleMax:
                            c || u || (t = !0);
                            break
                    }
                    t ? (n.setAttribute(`aria-disabled`, ``), n.setAttribute(`tabindex`, `-1`)) : (n.removeAttribute(`aria-disabled`), n.removeAttribute(`tabindex`))
                }
            }

            function J(t, n) {
                if (!t || !e || !h || !S || !j() || t === H.Swipe && Math.abs(S.getCurrentVelocities().scale) > .01) return;
                let r = {
                        ...b
                    },
                    i = {
                        ...b
                    },
                    a = Oe(xe() ? r.scale : y.scale),
                    o = S.getCurrentVelocities(),
                    s = ve();
                n ||= {};
                let c = (n.currentTouch?.length || 0) > 1,
                    l = n.velocityX || 0,
                    d = n.velocityY || 0,
                    f = n.center;
                n.srcEvent && (f = A(k(n.srcEvent)));
                let p = n.deltaX || 0,
                    m = n.deltaY || 0;
                switch (t) {
                    case H.MoveRight:
                        p = n.deltaX || 100;
                        break;
                    case H.MoveLeft:
                        p = n.deltaX || -100;
                        break;
                    case H.MoveUp:
                        m = n.deltaY || -100;
                        break;
                    case H.MoveDown:
                        m = n.deltaY || 100;
                        break
                }
                let _ = [];
                if (typeof t == `number`) i.scale = t;
                else switch (t) {
                    case H.Reset:
                        i = {
                            ...U
                        }, i.scale = q();
                        break;
                    case H.ZoomTo:
                    case H.ZoomIn:
                    case H.ZoomOut:
                    case H.ToggleCover:
                    case H.ToggleFull:
                    case H.ToggleMax:
                    case H.IterateZoom:
                    case H.Zoom:
                        i.scale = ze(t, n);
                        break;
                    case H.Pan:
                    case H.Move:
                    case H.MoveLeft:
                    case H.MoveRight:
                    case H.MoveUp:
                    case H.MoveDown:
                        if (X()) {
                            let e = 1,
                                t = 1;
                            i.x <= a.x[0] && l <= 0 && (e = Math.max(.01, 1 - Math.abs(1 / s.width * Math.abs(i.x - a.x[0]))), e *= .2), i.x >= a.x[1] && l >= 0 && (e = Math.max(.01, 1 - Math.abs(1 / s.width * Math.abs(i.x - a.x[1]))), e *= .2), i.y <= a.y[0] && d <= 0 && (t = Math.max(.01, 1 - Math.abs(1 / s.height * Math.abs(i.y - a.y[0]))), t *= .2), i.y >= a.y[1] && d >= 0 && (t = Math.max(.01, 1 - Math.abs(1 / s.height * Math.abs(i.y - a.y[1]))), t *= .2), i.x += p * e, i.y += m * t
                        } else i.x = u(a.x[0], i.x + p, a.x[1]), i.y = u(a.y[0], i.y + m, a.y[1]);
                        break;
                    case H.Swipe:
                        let e = (e = 0) => Math.sign(e) * Math.abs(e) ** 1.5;
                        i.x += u(-1e3, e(l), 1e3), i.y += u(-1e3, e(d), 1e3), d && !l && (i.x = u(a.x[0], i.x, a.x[1])), !d && l && (i.y = u(a.y[0], i.y, a.y[1])), o.x = l, o.y = d;
                        break;
                    case H.RotateCW:
                        i.angle += 90;
                        break;
                    case H.RotateCCW:
                        i.angle -= 90;
                        break;
                    case H.FlipX:
                        i.flipX *= -1;
                        break;
                    case H.FlipY:
                        i.flipY *= -1;
                        break
                }
                if (y.angle !== void 0 && Math.abs(y.angle) >= 360 && (i.angle -= Math.floor(y.angle / 360) * 360, y.angle -= Math.floor(y.angle / 360) * 360), _.length) {
                    let e = _.findIndex(e => e > i.scale + 1 / R);
                    i.scale = _[e] || _[0]
                }
                if (c && (i.scale = u(we() * (c ? .8 : 1), i.scale, De() * (c ? 1.6 : 1))), xe()) {
                    let e = Se(i.scale);
                    if (e) {
                        let {
                            x: t,
                            y: n
                        } = e;
                        i.x = t, i.y = n
                    }
                } else if (Math.abs(i.scale - r.scale) > 1e-4) {
                    let t = 0,
                        n = 0;
                    if (f) t = f.x, n = f.y;
                    else {
                        let r = e.getBoundingClientRect();
                        t = r.x + r.width * .5, n = r.y + r.height * .5
                    }
                    let o = t - s.left,
                        l = n - s.top;
                    o -= s.width * .5, l -= s.height * .5;
                    let d = (o - r.x) / r.scale,
                        p = (l - r.y) / r.scale;
                    i.x = o - d * i.scale, i.y = l - p * i.scale, !c && D(`bounds`) && (a = Oe(i.scale), i.x = u(a.x[0], i.x, a.x[1]), i.y = u(a.y[0], i.y, a.y[1]))
                }
                if (t === H.Swipe) {
                    let e = 500 * i.scale,
                        t = o;
                    S.spring({
                        tension: 94,
                        friction: 17,
                        maxSpeed: e,
                        restDelta: .1,
                        restSpeed: .1,
                        velocity: t
                    })
                } else t === H.Pan || c ? S.spring({
                    tension: 900,
                    friction: 17,
                    restDelta: .01,
                    restSpeed: .01,
                    maxSpeed: 1
                }) : S.spring({
                    tension: 170,
                    friction: 17,
                    restDelta: .001,
                    restSpeed: .001,
                    maxSpeed: 1 / 0,
                    velocity: o
                });
                if (n.velocity === 0 || g(y, i)) y = {
                    ...i
                }, b = {
                    ...i
                }, S.end(), Y(), Ae();
                else {
                    if (g(b, i)) return;
                    S.from(y).to(i).start()
                }
                P(`action`, t)
            }

            function Y() {
                if (!h || !d || !v) return;
                let {
                    width: e,
                    height: t
                } = ye();
                Object.assign(d.style, {
                    maxWidth: `min(${e}px, 100%)`,
                    maxHeight: `min(${t}px, 100%)`
                });
                let {
                    x: n,
                    y: r,
                    width: i,
                    height: a,
                    scale: o,
                    angle: s,
                    flipX: c,
                    flipY: l
                } = je(), u = `translate(${B(n,100)}px, ${B(r,100)}px)`;
                c !== 1 || l !== 1 ? u += ` scaleX(${B(o*c)}) scaleY(${B(o*l)})` : u += ` scale(${B(o)})`, s !== 0 && (u += ` rotate(${s}deg)`), v.style.width = `${B(i)}px`, v.style.height = `${B(a)}px`, v.style.transform = `${u}`, P(`render`)
            }

            function je() {
                let {
                    width: t,
                    height: n
                } = ye(), {
                    width: r,
                    height: i
                } = be();
                if (!e) return {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                    scale: 0,
                    flipX: 0,
                    flipY: 0,
                    angle: 0,
                    fitWidth: r,
                    fitHeight: i,
                    fullWidth: t,
                    fullHeight: n
                };
                let {
                    x: a,
                    y: o,
                    scale: s,
                    angle: c,
                    flipX: l,
                    flipY: u
                } = y, d = 1 / Ee(), f = t, p = n, m = y.scale * d, h = b.scale * d, g = Math.max(r, i), _ = Math.min(r, i);
                t > n ? (f = g, p = _) : (f = _, p = g), m = t > n ? g * s / t || 1 : g * s / n || 1;
                let v = f ? t * h : 0,
                    x = p ? n * h : 0,
                    S = f && p ? t * m / v : 0;
                return a = a + f * .5 - v * .5, o = o + p * .5 - x * .5, {
                    x: a,
                    y: o,
                    width: v,
                    height: x,
                    scale: S,
                    flipX: l,
                    flipY: u,
                    angle: c,
                    fitWidth: r,
                    fitHeight: i,
                    fullWidth: t,
                    fullHeight: n
                }
            }

            function Me() {
                return S
            }

            function Ne() {
                return x
            }

            function Pe() {
                return e
            }

            function Fe() {
                return h
            }

            function Ie() {
                return d
            }

            function Le() {
                return v
            }

            function Re() {
                P(`destroy`);
                for (let e of Object.values(l)) e?.destroy(Ze);
                for (let e of E) e();
                return d && (d.style.aspectRatio = ``, d.style.maxWidth = ``, d.style.maxHeight = ``), v && (v.style.width = ``, v.style.height = ``, v.style.transform = ``), d = void 0, h = void 0, v = void 0, y = {
                    ...U
                }, b = {
                    ...U
                }, S?.destroy(), S = void 0, x?.destroy(), x = void 0, s = W.Destroyed, Ze
            }

            function ze(e = D(`clickAction`), t = {}) {
                let n = b.scale,
                    r = q(),
                    i = [];
                if (typeof e == `number`) r = e;
                else if (e) {
                    switch (e) {
                        case H.ZoomTo:
                            r = t.scale || 1;
                            break;
                        case H.ZoomIn:
                            r = n * (t.scale || 2);
                            break;
                        case H.ZoomOut:
                            r = n * (t.scale || .5);
                            break;
                        case H.ToggleCover:
                            i = [q(), Te()];
                            break;
                        case H.ToggleFull:
                            i = [q(), Ee()];
                            break;
                        case H.ToggleMax:
                            i = [q(), De()];
                            break;
                        case H.IterateZoom:
                            i = [q(), Ee(), De()];
                            break;
                        case H.Zoom: {
                            let e = Ee();
                            r = n >= e - .05 ? q() : Math.min(e, n * (t.scale || 2));
                            break
                        }
                    }
                    i.length && (r = i.find(e => e > n + 1 / R) ?? q())
                }
                return e !== H.ZoomTo && (r = u(we(), r, De())), r
            }

            function Be() {
                return !!(j() && ze() > b.scale)
            }

            function Ve() {
                return !!(j() && ze() < b.scale)
            }

            function He() {
                return !!(j() && b.scale > we())
            }

            function Ue() {
                return !!(j() && b.scale < De())
            }

            function We() {
                return !!(j() && b.scale < Ee())
            }

            function Ge() {
                return !!(j() && (qe() || Ke(b.angle)) && x && !xe())
            }

            function Ke(e) {
                return Math.abs(e % 180) === 90
            }

            function X() {
                return !!(j() && x?.isPointerDown() && !xe())
            }

            function qe() {
                return !!(j() && b.scale > q())
            }

            function Je() {
                return !!(j() && b.scale >= Ee())
            }

            function Ye() {
                let t = `in-fullscreen`,
                    n = `with-panzoom-in-fullscreen`;
                e?.classList.toggle(t);
                let r = e?.classList.contains(t);
                r ? (document.documentElement.classList.add(n), document.addEventListener(`keydown`, Xe, !0)) : (document.documentElement.classList.remove(n), document.removeEventListener(`keydown`, Xe, !0)), Y(), P(r ? `enterFS` : `exitFS`)
            }

            function Xe(e) {
                e.key === `Escape` && !e.defaultPrevented && Ye()
            }
            let Ze = {
                canDrag: Ge,
                canZoomIn: Ue,
                canZoomOut: He,
                canZoomToFull: We,
                destroy: Re,
                emit: P,
                execute: J,
                getBoundaries: Oe,
                getContainer: Pe,
                getContent: Fe,
                getFullDim: ye,
                getGestures: Ne,
                getMousemovePos: Se,
                getOptions: function() {
                    return c
                },
                getPlugins: function() {
                    return l
                },
                getScale: Ce,
                getStartPosition: _e,
                getState: function() {
                    return s
                },
                getTransform: function(e) {
                    return e === !0 ? b : y
                },
                getTween: Me,
                getViewport: Le,
                getWrapper: Ie,
                init: F,
                isDragging: X,
                isExpanded: qe,
                isFullsize: Je,
                isMousemoveMode: xe,
                localize: O,
                off: ee,
                on: N,
                toggleFS: Ye,
                updateControls: Ae,
                version: `6.1.14`,
                willZoomIn: Be,
                willZoomOut: Ve
            };
            return Ze
        };
    oe.l10n = {
        en_EN: L
    }, oe.getDefaults = () => ne;
    let se = (e, t) => {
            let n = [];
            return e.childNodes.forEach(e => {
                e.nodeType === Node.ELEMENT_NODE && (!t || e.matches(t)) && n.push(e)
            }), n
        },
        K = {
            ...L,
            ERROR: `Something went wrong. <br /> Please try again later.`,
            NEXT: `Next page`,
            PREV: `Previous page`,
            GOTO: `Go to page #%d`,
            DOWNLOAD: `Download`,
            TOGGLE_FULLSCREEN: `Toggle full-screen mode`,
            TOGGLE_EXPAND: `Toggle full-size mode`,
            TOGGLE_THUMBS: `Toggle thumbnails`,
            TOGGLE_AUTOPLAY: `Toggle slideshow`
        },
        ce = function(e) {
            return e[e.Init = 0] = `Init`, e[e.Ready = 1] = `Ready`, e[e.Destroyed = 2] = `Destroyed`, e
        }({}),
        le = function(e) {
            return e[e.Loading = 0] = `Loading`, e[e.Loaded = 1] = `Loaded`, e[e.Error = 2] = `Error`, e
        }({}),
        ue = e => {
            e.cancelable && e.preventDefault()
        },
        de = {
            adaptiveHeight: !1,
            center: !0,
            classes: {
                container: `f-carousel`,
                isEnabled: `is-enabled`,
                isLTR: `is-ltr`,
                isRTL: `is-rtl`,
                isHorizontal: `is-horizontal`,
                isVertical: `is-vertical`,
                hasAdaptiveHeight: `has-adaptive-height`,
                viewport: `f-carousel__viewport`,
                slide: `f-carousel__slide`,
                isSelected: `is-selected`
            },
            dragFree: !1,
            enabled: !0,
            errorTpl: `<div class="f-html">{{ERROR}}</div>`,
            fill: !0,
            infinite: !0,
            initialPage: 0,
            l10n: K,
            rtl: !1,
            slides: [],
            slidesPerPage: `auto`,
            spinnerTpl: `<div class="f-spinner"></div>`,
            transition: `fade`,
            tween: {
                clamp: !0,
                mass: 1,
                tension: 160,
                friction: 25,
                restDelta: 1,
                restSpeed: 1,
                velocity: 0
            },
            vertical: !1
        },
        fe = 0,
        pe, me, he = (e, a = {}, s = {}) => {
            fe++;
            let l = ce.Init,
                h = {
                    ...de
                },
                g = {
                    ...de
                },
                _ = {},
                v, y, b, x = null,
                S = null,
                C = 0,
                E = 0,
                D = 0,
                O = !1,
                k = !1,
                A = !1,
                j = `height`,
                M = 0,
                N = !0,
                ee, P = 0,
                F = 0,
                L = 0,
                R = 0,
                z, B = `*`,
                V = [],
                H = [],
                te = new Set,
                U = [],
                W = [],
                ne = 0,
                re = 0,
                ie = 0;

            function G(e, ...t) {
                let n = g[e];
                return n && n instanceof Function ? n(Z, ...t) : n
            }

            function ae(e, t = []) {
                let n = G(`l10n`) || {};
                e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t) => n[t] || e);
                for (let n = 0; n < t.length; n++) e = e.split(t[n][0]).join(t[n][1]);
                return e = e.replace(/\{\{(.*?)\}\}/g, (e, t) => t), e
            }
            let oe = new Map;

            function K(e, ...t) {
                let n = [...oe.get(e) || []];
                g.on && n.push(g.on[e]);
                for (let e of n) e && e instanceof Function && e(Z, ...t);
                e === `click` && Ye(t[0]), e !== `*` && K(`*`, e, ...t)
            }

            function le(e, t) {
                for (let n of e instanceof Array ? e : [e]) oe.set(n, [...oe.get(n) || [], t]);
                return Z
            }

            function ge(e, t) {
                for (let n of e instanceof Array ? e : [e]) oe.has(n) && oe.set(n, oe.get(n).filter(e => e !== t));
                return Z
            }

            function _e() {
                if (!e || !r(e)) throw Error(`No Element found`);
                return l !== ce.Init && (ot(), l = ce.Init), x = e, h = a, window.removeEventListener(`resize`, ye), h.breakpoints && window.addEventListener(`resize`, ye), ye(), Z
            }

            function ve(e = {}, n) {
                return ot(), l = ce.Init, z = void 0, B = `*`, a = e, h = e, t(n) && (s = n), ye(), Z
            }

            function ye() {
                let e = c({}, de, h),
                    t = ``,
                    n = h.breakpoints || {};
                for (let [r, i] of Object.entries(n)) window.matchMedia(r).matches && (t += r, c(e, i));
                if (!(z !== void 0 && t === z)) {
                    if (z = t, l !== ce.Init) {
                        let t = W[P]?.slides[0]?.index;
                        t === void 0 && (t = g.initialSlide), e.initialSlide = t, e.slides = [];
                        for (let t of V) t.isVirtual && e.slides.push(t)
                    }
                    ot(), g = e, G(`enabled`) !== !1 && be()
                }
            }

            function be() {
                l = ce.Init, K(`init`), xe(), Se(), Ce(), Ge(), l = ce.Ready, f(x, (G(`classes`) || {}).isEnabled || ``), at(), Y(), Ee(), Oe(), we(), K(`ready`)
            }

            function xe() {
                for (let [e, t] of Object.entries({
                        ...s,
                        ...g.plugins || {}
                    }))
                    if (e && !_[e] && t instanceof Function) {
                        let n = t();
                        n.init(Z, he), _[e] = n
                    } K(`initPlugins`)
            }

            function Se() {
                if (!x) return;
                let e = G(`classes`) || {};
                f(x, e.container);
                let n = G(`style`);
                if (n && t(n))
                    for (let [e, t] of Object.entries(n)) x.style.setProperty(e, t);
                S = Array.from(x.querySelectorAll(`.${e.viewport}`)).filter(t => t.closest(`.${e.container}`) === x).pop() || null, S || (S = document.createElement(`div`), f(S, e.viewport), S.append(...se(x, `.${e.slide}`)), x.insertAdjacentElement(`afterbegin`, S)), x.carousel = Z, K(`initLayout`)
            }

            function Ce() {
                if (!S) return;
                let e = G(`classes`) || {};
                V = [], [...se(S, `.${e.slide}`)].forEach(e => {
                    if (e.parentElement) {
                        let t = Be({
                            el: e,
                            isVirtual: !1,
                            ...e.dataset || {}
                        });
                        K(`createSlide`, t), V.push(t)
                    }
                }), We();
                for (let e of V) K(`addSlide`, e);
                ze(G(`slides`));
                for (let e of V) {
                    let t = e.el;
                    t?.parentElement === S && (f(t, g.classes.slide), f(t, e.class), et(e), K(`attachSlideEl`, e))
                }
                K(`initSlides`)
            }

            function we() {
                if (!x || !S) return;
                x.addEventListener(`click`, Je), document.addEventListener(`mousemove`, q), me || (me = function(e) {
                    let t = e.target?.dataset?.carouselTarget;
                    t && (document.getElementById(`${t.split(`#`).pop()}`)?.carousel)?.emit(`click`, e)
                }, document.addEventListener(`click`, me));
                let e = S.getBoundingClientRect();
                if (ne = e.height, re = e.width, !b) {
                    let e = null;
                    b = new ResizeObserver(() => {
                        e ||= requestAnimationFrame(() => {
                            Te(), e = null
                        })
                    }), b.observe(S)
                }
            }

            function q(e) {
                pe = e
            }

            function Te() {
                if (l !== ce.Ready || !S) return;
                let e = W.length,
                    t = S.getBoundingClientRect(),
                    n = t.height,
                    r = t.width;
                e > 1 && (A && Math.abs(n - ne) < .5 || !A && Math.abs(r - re) < .5) || (Ge(), Oe(), ne = n, re = r, !(A && !ne || !A && !re) && (!x || !S || (e !== W.length || !v?.isPointerDown()) && (G(`dragFree`) && (O || M > L && M < R) ? (J(), at()) : nt(P, {
                    transition: !1
                }))))
            }

            function Ee() {
                y = w().on(`start`, () => {
                    (!v || !v.isPointerDown()) && (J(), at())
                }).on(`step`, e => {
                    let t = M;
                    M = e.pos, M !== t && (N = !1, at())
                }).on(`end`, e => {
                    v?.isPointerDown() || (M = e.pos, y && !O && (M < L || M > R) ? y.spring({
                        clamp: !0,
                        mass: 1,
                        tension: 200,
                        friction: 25,
                        velocity: 0,
                        restDelta: 1,
                        restSpeed: 1
                    }).from({
                        pos: M
                    }).to({
                        pos: u(L, M, R)
                    }).start() : N || (N = !0, K(`settle`)))
                })
            }

            function De() {
                let e = G(`gestures`);
                v || e === !1 || !S || (v = I(S, e).on(`start`, e => {
                    if (!y || G(`gestures`, e) === !1) return;
                    let {
                        srcEvent: t
                    } = e;
                    A && T(t) && !o(t.target) && ue(t), y.pause(), y.getCurrentVelocities().pos = 0;

                    function n(e) {
                        let t = window.getComputedStyle(e),
                            n = new DOMMatrixReadOnly(t.transform);
                        return {
                            width: n.m41 || 0,
                            height: n.m42 || 0
                        }
                    }
                    let r = W[P]?.slides[0],
                        i = r?.el;
                    r && te.has(r.index) && i && (M = r.offset || 0, M += (n(i)[j] || 0) * (k && !A ? 1 : -1)), X(), O || (M < L || M > R) && y.spring({
                        clamp: !0,
                        mass: 1,
                        tension: 500,
                        friction: 25,
                        velocity: y.getCurrentVelocities()?.pos || 0,
                        restDelta: 1,
                        restSpeed: 1
                    }).from({
                        pos: M
                    }).to({
                        pos: u(L, M, R)
                    }).start()
                }).on(`move`, e => {
                    if (G(`gestures`, e) === !1) return;
                    let {
                        srcEvent: t,
                        axis: n,
                        deltaX: r,
                        deltaY: i
                    } = e;
                    if (T(t) && t.touches?.length > 1) return;
                    let a = t.target,
                        s = o(a),
                        c = s ? s.scrollHeight > s.clientHeight ? `y` : `x` : void 0;
                    if (s && s !== S && (!n || n === c)) return;
                    if (!n) {
                        ue(t), t.stopPropagation(), t.stopImmediatePropagation();
                        return
                    }
                    if (n === `y` && !A || n === `x` && A || (ue(t), t.stopPropagation(), !y)) return;
                    let l = k && !A ? 1 : -1,
                        u = A ? i : r,
                        d = y?.isRunning() ? y.getEndValues().pos : M,
                        f = 1;
                    O || (d <= L && u * l < 0 ? (f = Math.max(.01, 1 - (Math.abs(1 / Pe() * Math.abs(d - L)) || 0)), f *= .2) : d >= R && u * l > 0 && (f = Math.max(.01, 1 - (Math.abs(1 / Pe() * Math.abs(d - R)) || 0)), f *= .2)), d += u * f * l, y.spring({
                        clamp: !0,
                        mass: 1,
                        tension: 700,
                        friction: 25,
                        velocity: y.getCurrentVelocities()?.pos || 0,
                        restDelta: 1,
                        restSpeed: 1
                    }).from({
                        pos: M
                    }).to({
                        pos: d
                    }).start()
                }).on(`panstart`, e => {
                    G(`gestures`, e) !== !1 && e?.axis === (A ? `y` : `x`) && f(S, `is-dragging`)
                }).on(`panend`, e => {
                    G(`gestures`, e) !== !1 && p(S, `is-dragging`)
                }).on(`end`, e => {
                    if (G(`gestures`, e) === !1) return;
                    let {
                        srcEvent: t,
                        axis: n,
                        velocityX: r,
                        velocityY: i,
                        currentTouch: a
                    } = e;
                    if (a.length > 0 || !y) return;
                    let s = t.target,
                        c = o(s),
                        l = c ? c.scrollHeight > c.clientHeight ? `y` : `x` : void 0,
                        d = c && (!n || n === l);
                    A && T(t) && !n && Je(t);
                    let f = W.length,
                        p = G(`dragFree`);
                    if (!f) return;
                    let m = d ? 0 : G(`vertical`) ? i : r;
                    n !== (A ? `y` : `x`) && (m = 0);
                    let h = y?.isRunning() ? y.getEndValues().pos : M,
                        g = k && !A ? 1 : -1;
                    if (d || (h += m * (p ? 5 : 1) * g), !O && (m * g <= 0 && h < L || m * g >= 0 && h > R)) {
                        let e = 0;
                        Math.abs(m) > 0 && (e = Math.abs(m) * 2, e = Math.min(Pe() * .3, e)), h = u(L + e * -1, h, R + e), y.spring({
                            clamp: !0,
                            mass: 1,
                            tension: 380,
                            friction: 25,
                            velocity: m * -1,
                            restDelta: 1,
                            restSpeed: 1
                        }).from({
                            pos: M
                        }).to({
                            pos: h
                        }).start();
                        return
                    }
                    if (p || _.Autoscroll?.isEnabled()) {
                        Math.abs(m) > 10 ? y.spring({
                            clamp: !0,
                            mass: 1,
                            tension: 150,
                            friction: 25,
                            velocity: m * -1,
                            restDelta: 1,
                            restSpeed: 1
                        }).from({
                            pos: M
                        }).to({
                            pos: h
                        }).start() : y.isRunning() || N || (N = !0, K(`settle`));
                        return
                    }
                    if (!(p || _.Autoscroll?.isEnabled()) && (!(e.offsetX || e.offsetY) || n === `y` && !A || n === `x` && A)) {
                        nt(P, {
                            transition: `tween`
                        });
                        return
                    }
                    let v = Me(h);
                    Math.abs(m) > 10 && v === P && (m > 0 ? v += k && !A ? 1 : -1 : v += k && !A ? -1 : 1), nt(v, {
                        transition: `tween`,
                        tween: {
                            velocity: m * -1
                        }
                    })
                }).init())
            }

            function Oe() {
                G(`gestures`) === !1 ? v &&= (v.destroy(), void 0) : v || De(), m(S, `is-draggable`, !!v && W.length > 0)
            }

            function ke(e = `*`) {
                let t = [];
                for (let n of V)(e === `*` || n.class && n.class.includes(e) || n.el && n.el?.classList.contains(e)) && t.push(n);
                ee = void 0, B = e, H = [...t]
            }

            function Ae() {
                ee = void 0, P = G(`initialPage`);
                let e = G(`initialSlide`) || void 0;
                e !== void 0 && (P = Z.getPageIndex(e) || 0), P = u(0, P, W.length - 1), M = W[P]?.pos || 0, F = M
            }

            function J() {
                if (!y) return;
                let e = Me(y?.isRunning() ? y.getEndValues().pos : M);
                e !== P && (ee = P, P = e, et(), Y(), je(), K(`change`, P, ee))
            }

            function Y() {
                if (!x) return;
                for (let e of x.querySelectorAll(`[data-carousel-index]`)) e.innerHTML = P + ``;
                for (let e of x.querySelectorAll(`[data-carousel-page]`)) e.innerHTML = P + 1 + ``;
                for (let e of x.querySelectorAll(`[data-carousel-pages]`)) e.innerHTML = W.length + ``;
                let e = G(`classes`) || {},
                    t = Array.from(x.querySelectorAll(`[data-carousel-go-to]`)).filter(t => t.closest(`.${e.container}`) === x);
                for (let e of t) parseInt(e.dataset?.carouselGoTo || `-1`, 10) === P ? e.setAttribute(`aria-current`, `true`) : e.removeAttribute(`aria-current`);
                for (let e of x.querySelectorAll(`[data-carousel-go-prev]`)) e.toggleAttribute(`aria-disabled`, !st()), st() ? e.removeAttribute(`tabindex`) : e.setAttribute(`tabindex`, `-1`);
                for (let e of x.querySelectorAll(`[data-carousel-go-next]`)) e.toggleAttribute(`aria-disabled`, !ct()), ct() ? e.removeAttribute(`tabindex`) : e.setAttribute(`tabindex`, `-1`);
                let n = !1,
                    r = W[P]?.slides[0];
                r && (r.downloadSrc || r.type === `image` && r.src) && (n = !0);
                for (let e of x.querySelectorAll(`[data-carousel-download]`)) e.toggleAttribute(`aria-disabled`, !n)
            }

            function je(e) {
                e ||= W[P]?.slides[0];
                let t = e?.el;
                if (t)
                    for (let n of t.querySelectorAll(`[data-slide-index]`)) n.innerHTML = e.index + 1 + ``
            }

            function Me(e) {
                if (!W.length) return 0;
                let t = Ie(),
                    n = e;
                O ? n -= Math.floor((e - W[0]?.pos) / t) * t || 0 : n = u(W[0]?.pos, e, W[W.length - 1]?.pos);
                let r = new Map,
                    i = 0;
                for (let e of W) {
                    let a = Math.abs(e.pos - n),
                        o = Math.abs(e.pos - n - t),
                        s = Math.abs(e.pos - n + t),
                        c = Math.min(a, o, s);
                    r.set(i, c), i++
                }
                let a = r.size > 0 ? [...r.entries()].reduce((e, t) => t[1] < e[1] ? t : e) : [P, 0];
                return parseInt(a[0])
            }

            function Ne() {
                return ie
            }

            function Pe() {
                return C
            }

            function Fe() {
                let e = 0;
                if (S) {
                    let t = document.createElement(`div`);
                    t.style.display = `block`, f(t, g.classes.slide), S.appendChild(t), e = t.getBoundingClientRect()[j], t.remove(), t = void 0
                }
                return e
            }

            function Ie(e = !0) {
                return H.length ? H.reduce((e, t) => e + t.dim, 0) + (H.length - (O && e ? 0 : 1)) * ie : 0
            }

            function Le(e) {
                let t = Ie(),
                    n = Pe();
                if (!t || !S || !n) return [];
                let r = [];
                e = e === void 0 ? M : e, O && (e -= Math.floor(e / t) * t || 0);
                let i = 0;
                for (let a of H) {
                    let o = (t = 0) => {
                        r.indexOf(a) > -1 || (a.pos = i - e + t || 0, a.offset + t > e - a.dim - E + .51 && a.offset + t < e + n + D - .51 && r.push(a))
                    };
                    a.offset = i, O && (o(t), o(t * -1)), o(), i += a.dim + ie
                }
                return r
            }

            function Re() {
                if (!x) return;
                let e = Pe(),
                    t = Ie(!1),
                    n = G(`slidesPerPage`);
                n = n === `auto` ? 1 / 0 : parseFloat(n + ``), W = [];
                let r = 0,
                    i = 0;
                for (let t of H)(!W.length || r + t.dim - e > .05 || i >= n) && (W.push({
                    index: W.length,
                    slides: [],
                    dim: 0,
                    offset: 0,
                    pos: 0
                }), r = 0, i = 0), W[W.length - 1]?.slides.push(t), r += t.dim + ie, i++;
                let a = G(`center`),
                    o = G(`fill`),
                    s = 0;
                for (let n of W) {
                    n.dim = (n.slides.length - 1) * ie;
                    for (let e of n.slides) n.dim += e.dim;
                    n.offset = s, n.pos = s, a !== !1 && (n.pos -= (e - n.dim) * .5), o && !O && t > e && (n.pos = u(0, n.pos, t - e)), s += n.dim + ie
                }
                let c = [],
                    l;
                for (let e of W) {
                    let t = {
                        ...e
                    };
                    l && Math.abs(t.pos - l.pos) < .1 ? (l.dim += t.dim, l.slides = [...l.slides, ...t.slides]) : (l = t, t.index = c.length, c.push(t))
                }
                W = c, P = u(0, P, W.length - 1)
            }

            function ze(e, t) {
                let n = [];
                for (let t of Array.isArray(e) ? e : [e]) {
                    let e = Be({
                        ...t,
                        isVirtual: !0
                    });
                    e.el ||= document.createElement(`div`), K(`createSlide`, e), n.push(e)
                }
                V.splice(t === void 0 ? V.length : t, 0, ...n), We();
                for (let e of n) K(`addSlide`, e), Ve(e);
                return ke(B), n
            }

            function Be(e) {
                return (n(e) || e instanceof HTMLElement) && (e = {
                    html: e
                }), {
                    index: -1,
                    el: void 0,
                    class: ``,
                    isVirtual: !0,
                    dim: 0,
                    pos: 0,
                    offset: 0,
                    html: ``,
                    src: ``,
                    ...e
                }
            }

            function Ve(e) {
                let t = e.el;
                if (!e || !t) return;
                let n = e.html ? e.html instanceof HTMLElement ? e.html : i(e.html) : void 0;
                n && (f(n, `f-html`), e.htmlEl = n, f(t, `has-html`), t.append(n), K(`contentReady`, e))
            }

            function He(e) {
                if (!S || !e) return;
                let t = e.el;
                if (t) {
                    if (t.setAttribute(`index`, e.index + ``), t.parentElement !== S) {
                        f(t, g.classes.slide), f(t, e.class), et(e);
                        let n;
                        for (let t of V)
                            if (t.index > e.index) {
                                n = t.el;
                                break
                            } S.insertBefore(t, n && S.contains(n) ? n : null), K(`attachSlideEl`, e)
                    }
                    return je(e), t
                }
            }

            function Ue(e) {
                let t = e?.el;
                t && (t.remove(), Ke(t), K(`detachSlideEl`, e))
            }

            function We() {
                for (let e = 0; e < V.length; e++) {
                    let t = V[e],
                        n = t.el;
                    n && (t.index !== e && Ke(n), n.setAttribute(`index`, `${e}`)), t.index = e
                }
            }

            function Ge() {
                if (!x || !S) return;
                k = G(`rtl`), A = G(`vertical`), j = A ? `height` : `width`;
                let e = G(`classes`);
                if (m(x, e.isLTR, !k), m(x, e.isRTL, k), m(x, e.isHorizontal, !A), m(x, e.isVertical, A), m(x, e.hasAdaptiveHeight, G(`adaptiveHeight`)), C = 0, E = 0, D = 0, ie = 0, S) {
                    S.childElementCount || (S.style.display = `grid`);
                    let e = S.getBoundingClientRect();
                    C = S.getBoundingClientRect()[j] || 0;
                    let t = window.getComputedStyle(S);
                    ie = parseFloat(t.getPropertyValue(`--f-carousel-gap`)) || 0, t.getPropertyValue(`overflow-` + (A ? `y` : `x`)) === `visible` && (E = Math.abs(e[A ? `top` : `left`]), D = Math.abs(window[A ? `innerHeight` : `innerWidth`] - e[A ? `bottom` : `right`])), S.style.display = ``
                }
                if (!C) return;
                let t = Fe();
                for (let e of H) {
                    let n = e.el,
                        i = 0;
                    if (e.isVirtual || !n || !r(n)) i = t;
                    else {
                        let e = !1;
                        (!n.parentElement || n.parentElement !== S) && (S.appendChild(n), e = !0), i = n.getBoundingClientRect()[j], e && n.parentElement?.removeChild(n)
                    }
                    e.dim = i
                }
                if (O = !1, G(`infinite`)) {
                    O = !0;
                    let e = Ie(),
                        t = C + E + D;
                    for (let n = 0; n < H.length; n++) {
                        let r = H[n]?.dim + ie;
                        if (e - r < t && e - r - t < r) {
                            O = !1;
                            break
                        }
                    }
                }
                Re(), L = W[0]?.pos || 0, R = W[W.length - 1]?.pos || 0, l === ce.Init ? Ae() : F = W[P || 0]?.pos || 0, K(`refresh`), Y()
            }

            function Ke(e) {
                if (!e || !r(e)) return;
                let t = parseInt(e.getAttribute(`index`) || `-1`),
                    n = ``;
                for (let t of Array.from(e.classList)) {
                    let e = t.match(/^f-(\w+)(Out|In)$/);
                    e && e[1] && (n = e[1] + ``)
                }
                if (!e || !n) return;
                let i = [`f-${n}Out`, `f-${n}In`, `to-prev`, `to-next`, `from-prev`, `from-next`];
                e.removeEventListener(`animationend`, qe), p(e, i.join(` `)), te.delete(t)
            }

            function X() {
                if (!S) return;
                let e = te.size > 0;
                for (let e of H) Ke(e.el);
                te.clear(), e && at()
            }

            function qe(e) {
                e.animationName?.substring(0, 2) === `f-` && (Ke(e.target), te.size || (p(x, `in-transition`), !N && Math.abs(Z.getPosition(!0) - F) < .5 && (N = !0, K(`settle`))), at())
            }

            function Je(e) {
                Ye(e), K(`click`, e)
            }

            function Ye(e) {
                if (e.defaultPrevented) return;
                let t = e.composedPath()[0];
                if (t.closest(`[data-carousel-go-prev]`)) {
                    ue(e), Z.prev();
                    return
                }
                if (t.closest(`[data-carousel-go-next]`)) {
                    ue(e), Z.next();
                    return
                }
                let n = t.closest(`[data-carousel-go-to]`);
                if (n) {
                    ue(e), Z.goTo(parseFloat(n.dataset.carouselGoTo || ``) || 0);
                    return
                }
                if (t.closest(`[data-carousel-download]`)) {
                    ue(e);
                    let t = W[P]?.slides[0];
                    if (t && (t.downloadSrc || t.type === `image` && t.src)) {
                        let e = t.downloadFilename,
                            n = document.createElement(`a`),
                            r = t.downloadSrc || t.src || ``;
                        n.href = r, n.target = `_blank`, n.download = e || r, n.click()
                    }
                    return
                }
            }

            function Xe(e) {
                let t = e.el,
                    n = t?.querySelector(`.f-spinner`);
                if (!t || n) return Z;
                let r = i(G(`spinnerTpl`));
                return r && (f(r, `f-spinner`), t.insertAdjacentElement(`beforeend`, r)), Z
            }

            function Ze(e) {
                let t = e.el;
                t && t.querySelector(`.f-spinner`)?.remove()
            }

            function Qe(e, t) {
                if (l === ce.Ready) {
                    Ze(e), $e(e);
                    let n = e.el;
                    if (n) {
                        let r = document.createElement(`div`);
                        f(r, `f-html`), f(r, `is-error`), r.innerHTML = ae(t || `<p>{{ERROR}}</p>`), e.htmlEl = r, f(n, `has-html has-error`), n.insertAdjacentElement(`afterbegin`, r), K(`contentReady`, e)
                    }
                }
                return Z
            }

            function $e(e) {
                let t = e.el;
                t && (t.querySelector(`.f-html.is-error`)?.remove(), p(t, `has-error`))
            }

            function et(e) {
                e ||= W[P]?.slides[0];
                let t = e?.el;
                if (!t) return;
                let r = G(`formatCaption`, e);
                r === void 0 && (r = e.caption), r ||= ``;
                let i = G(`captionEl`);
                if (i && i instanceof HTMLElement) {
                    if (e.index !== P) return;
                    if (n(r) && (i.innerHTML = ae(r + ``)), r instanceof HTMLElement) {
                        if (r.parentElement === i) return;
                        i.innerHTML = ``, r.parentElement && (r = r.cloneNode(!0)), i.append(r)
                    }
                    return
                }
                if (!r) return;
                let a = e.captionEl || t.querySelector(`.f-caption`);
                !a && r instanceof HTMLElement && r.classList.contains(`f-caption`) && (a = r), a || (a = document.createElement(`div`), f(a, `f-caption`), n(r) ? a.innerHTML = ae(r + ``) : r instanceof HTMLElement && (r.parentElement && (r = r.cloneNode(!0)), a.append(r)));
                let o = `f-caption-${fe}_${e.index}`;
                a.setAttribute(`id`, o), a.dataset.selectable = `true`, f(t, `has-caption`), t.setAttribute(`aria-labelledby`, o), e.captionEl = a, t.insertAdjacentElement(`beforeend`, a)
            }

            function tt(e, t) {
                if (!x || !C || !y || !t || !n(t) || t === `tween`) return !1;
                for (let e of U)
                    if (C - e.dim > .5) return !1;
                if (E > .5 || D > .5) return;
                let r = W.length,
                    i = e > P ? 1 : -1;
                e = O ? (e % r + r) % r : u(0, e, r - 1), k && (i *= -1);
                let a = W[P]?.slides[0],
                    o = a?.index,
                    s = W[e]?.slides[0],
                    c = s?.index,
                    l = W[e]?.pos;
                if (c === void 0 || o === void 0 || o === c || M === l || Math.abs(C - (s?.dim || 0)) > 1) return !1;
                N = !1, y.pause(), X(), f(x, `in-transition`), M = F = l;
                let d = He(a),
                    m = He(s);
                return J(), d && (te.add(o), d.style.transform = ``, d.addEventListener(`animationend`, qe), p(d, g.classes.isSelected), d.inert = !1, f(d, `f-${t}Out to-${i>0?`next`:`prev`}`)), m && (te.add(c), m.style.transform = ``, m.addEventListener(`animationend`, qe), f(m, g.classes.isSelected), m.inert = !1, f(m, `f-${t}In from-${i>0?`prev`:`next`}`)), at(), !0
            }

            function nt(e, n = {}) {
                let {
                    transition: r,
                    tween: i
                } = {
                    transition: g.transition,
                    tween: g.tween,
                    ...n || {}
                };
                if (!x || !y) return;
                let a = W.length;
                if (!a || tt(e, r)) return;
                e = O ? (e % a + a) % a : u(0, e, a - 1), F = W[e || 0]?.pos || 0;
                let o = y.isRunning() ? y.getEndValues().pos : M;
                if (Math.abs(F - o) < 1) {
                    M = F, P !== e && (et(), ee = P, P = e, Y(), je(), K(`change`, P, ee)), at(), N || (N = !0, K(`settle`));
                    return
                }
                if (y.pause(), X(), O) {
                    let e = Ie(),
                        t = Math.floor((o - W[0]?.pos) / e) || 0,
                        n = F + t * e,
                        r = n - e;
                    F = [n + e, n, r].reduce(function(e, t) {
                        return Math.abs(t - o) < Math.abs(e - o) ? t : e
                    })
                }
                if (r !== !1 && t(i)) {
                    y.spring(c({}, g.tween, i)).from({
                        pos: M
                    }).to({
                        pos: F
                    }).start();
                    return
                }
                M = F, J(), at(), N || (N = !0, K(`settle`))
            }

            function rt(e) {
                let t = M;
                if (O && e !== !0) {
                    let e = Ie(),
                        n = Math.floor((M - W[0]?.pos || 0) / e) || 0;
                    t -= n * e
                }
                return t
            }

            function it(e) {
                M = e, J(), at()
            }

            function at() {
                if (!x || !S) return;
                U = Le();
                let e = new Set,
                    t = [],
                    n = W[P],
                    r = g.setTransform,
                    i;
                for (let r of H) {
                    let a = te.has(r.index),
                        o = U.indexOf(r) > -1,
                        s = n?.slides?.indexOf(r) > -1;
                    if (r.isVirtual && !a && !o) continue;
                    let c = He(r);
                    if (c && (t.push(r), s && e.add(c), G(`adaptiveHeight`) && s)) {
                        let e = (c.lastElementChild || c).getBoundingClientRect().height;
                        i = i == null ? e : Math.max(i, e)
                    }
                }
                S && i && (S.style.height = `${i}px`), [...se(S, `.${g.classes.slide}`)].forEach(t => {
                    m(t, g.classes.isSelected, e.has(t));
                    let n = V[parseInt(t.getAttribute(`index`) || `-1`)];
                    if (!n) {
                        t.remove(), Ke(t);
                        return
                    }
                    let i = te.has(n.index),
                        a = U.indexOf(n) > -1;
                    if (n.isVirtual && !i && !a) {
                        Ue(n);
                        return
                    }
                    if (t.inert = !a, r === !1) return;
                    let o = n.pos ? Math.round(n.pos * 1e4) / 1e4 : 0,
                        s = 0,
                        c = 0,
                        l = 0,
                        u = 0;
                    i || (s = A ? 0 : k ? o * -1 : o, c = A ? o : 0, l = d(s, 0, n.dim, 0, 100), u = d(c, 0, n.dim, 0, 100)), r instanceof Function && !i ? r(Z, n, {
                        x: s,
                        y: c,
                        xPercent: l,
                        yPercent: u
                    }) : t.style.transform = s || c ? `translate3d(${l}%, ${u}%,0)` : ``
                }), K(`render`, t)
            }

            function ot() {
                x?.removeEventListener(`click`, Je), document.removeEventListener(`mousemove`, q), te.clear(), b?.disconnect(), b = void 0;
                for (let e of V) {
                    let t = e.el;
                    t && r(t) && (e.state = void 0, Ze(e), $e(e), e.isVirtual ? (Ue(e), e.el = void 0) : (Ke(t), t.style.transform = ``, S && !S.contains(t) && S.appendChild(t)))
                }
                for (let e of Object.values(_)) e?.destroy();
                _ = {}, v?.destroy(), v = void 0, y?.destroy(), y = void 0;
                for (let [e, t] of Object.entries(g.classes || {})) e !== `container` && p(x, t);
                p(S, `is-draggable`)
            }

            function st() {
                return O || P > 0
            }

            function ct() {
                return O || P < W.length - 1
            }
            let Z = {
                add: function(e, t) {
                    let n = M,
                        r = P,
                        i = Ie(),
                        a = y?.isRunning() ? y.getEndValues().pos : M,
                        o = i && Math.floor((a - (W[0]?.pos || 0)) / i) || 0;
                    return ze(e, t), ke(B), Ge(), y && i && (r === P && (n -= o * i), n === F ? M = F : y.spring({
                        clamp: !0,
                        mass: 1,
                        tension: 300,
                        friction: 25,
                        restDelta: 1,
                        restSpeed: 1
                    }).from({
                        pos: n
                    }).to({
                        pos: F
                    }).start()), at(), Z
                },
                canGoPrev: st,
                canGoNext: ct,
                destroy: function() {
                    return K(`destroy`), window.removeEventListener(`resize`, ye), ot(), oe.clear(), x = null, W = [], V = [], g = {
                        ...de
                    }, _ = {}, H = [], z = void 0, B = `*`, l = ce.Destroyed, Z
                },
                emit: K,
                filter: function(e = `*`) {
                    return ke(e), Ge(), M = u(L, M, R), at(), K(`filter`, e), Z
                },
                getContainer: function() {
                    return x
                },
                getGapDim: Ne,
                getGestures: function() {
                    return v
                },
                getLastMouseMove: function() {
                    return pe
                },
                getOption: function(e) {
                    return G(e)
                },
                getOptions: function() {
                    return g
                },
                getPage: function() {
                    return W[P]
                },
                getPageIndex: function(e) {
                    if (e !== void 0) {
                        for (let t of W || [])
                            for (let n of t.slides)
                                if (n.index === e) return t.index;
                        return -1
                    }
                    return P
                },
                getPageIndexFromPosition: Me,
                getPageProgress: function(e, t) {
                    e === void 0 && (e = P);
                    let n = W[e];
                    if (!n) return e > P ? -1 : 1;
                    let r = Ie(),
                        i = Ne(),
                        a = n.pos,
                        o = rt();
                    if (O && t !== !0) {
                        let e = Math.floor((o - W[0]?.pos) / r) || 0;
                        o -= e * r, a = [a + r, a, a - r].reduce(function(e, t) {
                            return Math.abs(t - o) < Math.abs(e - o) ? t : e
                        })
                    }
                    return (o - a) / (n.dim + i) || 0
                },
                getPageVisibility: function(e) {
                    e === void 0 && (e = P);
                    let t = W[e];
                    if (!t) return e > P ? -1 : 1;
                    let n = rt(),
                        r = Pe(),
                        i = t.pos;
                    if (O) {
                        let e = Ie(),
                            t = Math.floor((n - W[0]?.pos) / e) || 0,
                            r = i + t * e,
                            a = r - e;
                        i = [r + e, r, a].reduce(function(e, t) {
                            return Math.abs(t - n) < Math.abs(e - n) ? t : e
                        })
                    }
                    return i > n && i + t.dim < n + r ? 1 : i < n ? (i + t.dim - n) / t.dim || 0 : i + t.dim > n + r && (n + r - i) / t.dim || 0
                },
                getPages: function() {
                    return W
                },
                getPlugins: function() {
                    return _
                },
                getPosition: rt,
                getSlides: function() {
                    return V
                },
                getState: function() {
                    return l
                },
                getTotalSlideDim: Ie,
                getTween: function() {
                    return y
                },
                getViewport: function() {
                    return S
                },
                getViewportDim: Pe,
                getVisibleSlides: function(e) {
                    return e === void 0 ? U : Le(e)
                },
                goTo: nt,
                hasNavigated: function() {
                    return ee !== void 0
                },
                hideError: $e,
                hideLoading: Ze,
                init: _e,
                isInfinite: function() {
                    return O
                },
                isInTransition: function() {
                    return te.size > 0
                },
                isRTL: function() {
                    return k
                },
                isSettled: function() {
                    return N
                },
                isVertical: function() {
                    return A
                },
                localize: ae,
                next: function(e = {}) {
                    return nt(P + 1, e), Z
                },
                off: ge,
                on: le,
                prev: function(e = {}) {
                    return nt(P - 1, e), Z
                },
                reInit: ve,
                remove: function(e) {
                    e === void 0 && (e = V.length - 1);
                    let t = V[e];
                    return t && (K(`removeSlide`, t), t.el &&= (Ke(t.el), t.el.remove(), void 0), V.splice(e, 1), ke(B), Ge(), M = u(L, M, R), at()), Z
                },
                setPosition: it,
                showError: Qe,
                showLoading: Xe,
                version: `6.1.14`
            };
            return Z
        };
    he.l10n = {
        en_EN: K
    }, he.getDefaults = () => de;
    let ge = function(e = ``, t = ``, n = ``) {
            return e.split(t).join(n)
        },
        _e = {
            tpl: e => `<img class="f-panzoom__content" 
    ${e.srcset?`data-lazy-srcset="{{srcset}}"`:``} 
    ${e.sizes?`data-lazy-sizes="{{sizes}}"`:``} 
    data-lazy-src="{{src}}" alt="{{alt}}" />`
        },
        ve = () => {
            let e;

            function r(n, r) {
                let i = e?.getOptions().Zoomable,
                    a = (t(i) ? {
                        ..._e,
                        ...i
                    } : _e)[n];
                return a && typeof a == `function` && r ? a(r) : a
            }

            function i() {
                e && e.getOptions().Zoomable !== !1 && (e.on(`addSlide`, s), e.on(`removeSlide`, c), e.on(`attachSlideEl`, l), e.on(`click`, o), e.on(`change`, a), e.on(`ready`, a))
            }

            function a() {
                u();
                let t = e?.getVisibleSlides() || [];
                if (t.length > 1 || e?.getOption(`transition`) === `slide`)
                    for (let n of t) {
                        let t = n.panzoomRef;
                        t && (e?.getPage().slides || []).indexOf(n) < 0 && t.execute(H.ZoomTo, {
                            ...t.getStartPosition()
                        })
                    }
            }

            function o(e, t) {
                let n = t.target;
                !n || t.defaultPrevented || n.dataset.panzoomAction && d(n.dataset.panzoomAction)
            }

            function s(t, i) {
                let a = i.el;
                if (!e || !a || i.panzoomRef) return;
                let o = i.src || i.lazySrc || ``,
                    s = i.alt || i.caption || `Image #${i.index}`,
                    c = i.srcset || i.lazySrcset || ``,
                    l = i.sizes || i.lazySizes || ``;
                if (o && n(o) && !i.html && (!i.type || i.type === `image`)) {
                    i.type = `image`, i.thumbSrc = i.thumbSrc || o;
                    let e = r(`tpl`, i);
                    e = ge(e, `{{src}}`, o + ``), e = ge(e, `{{srcset}}`, c + ``), e = ge(e, `{{sizes}}`, l + ``), a.insertAdjacentHTML(`afterbegin`, e)
                }
                let d = a.querySelector(`.f-panzoom__content`);
                if (!d) return;
                d.setAttribute(`alt`, s + ``);
                let f = oe(a, {
                    width: i.width && i.width !== `auto` ? parseFloat(i.width + ``) : `auto`,
                    height: i.height && i.height !== `auto` ? parseFloat(i.height + ``) : `auto`,
                    classes: {
                        container: `f-zoomable`
                    },
                    event: () => e?.getLastMouseMove(),
                    spinnerTpl: () => e?.getOption(`spinnerTpl`) || ``,
                    ...r(`Panzoom`)
                });
                f.on(`*`, (t, n, ...r) => {
                    e && (n === `loading` && (i.state = 0), n === `loaded` && (i.state = 1), n === `error` && (i.state = 2, e?.showError(i, `{{IMAGE_ERROR}}`)), e.emit(`panzoom:${n}`, i, ...r), n === `loading` && e.emit(`contentLoading`, i), n === `ready` && e.emit(`contentReady`, i), i.index === e?.getPageIndex() && u())
                }), i.panzoomRef = f
            }

            function c(e, t) {
                t.panzoomRef &&= (t.panzoomRef.destroy(), void 0)
            }

            function l(e, t) {
                let n = t.panzoomRef;
                if (n) switch (n.getState()) {
                    case W.Init:
                        n.init();
                        break;
                    case W.Ready:
                        n.execute(H.ZoomTo, {
                            ...n.getStartPosition(),
                            velocity: 0
                        });
                        break
                }
            }

            function u() {
                let t = e?.getContainer() || void 0,
                    n = e?.getPage()?.slides[0]?.panzoomRef;
                if (t)
                    if (n) n.updateControls(t);
                    else
                        for (let e of t.querySelectorAll(`[data-panzoom-action]`) || []) e.setAttribute(`aria-disabled`, ``), e.setAttribute(`tabindex`, `-1`)
            }

            function d(t, ...n) {
                e?.getPage().slides[0].panzoomRef?.execute(t, ...n)
            }
            return {
                init: function(t) {
                    e = t, e.on(`initPlugins`, i)
                },
                destroy: function() {
                    if (e) {
                        e.off(`initPlugins`, i), e.off(`addSlide`, s), e.off(`removeSlide`, c), e.off(`attachSlideEl`, l), e.off(`click`, o), e.off(`change`, a), e.off(`ready`, a);
                        for (let t of e.getSlides()) c(e, t)
                    }
                    e = void 0
                },
                execute: d
            }
        },
        ye = {
            syncOnChange: !1,
            syncOnClick: !0,
            syncOnHover: !1
        },
        be = () => {
            let e, n;

            function r() {
                let n = e?.getOptions().Sync;
                return t(n) ? {
                    ...ye,
                    ...n
                } : ye
            }

            function i(t) {
                !e || !t || (n = t, e.getOptions().classes = {
                    ...e.getOptions().classes,
                    isSelected: ``
                }, e.getOptions().initialSlide = n.getPage()?.slides[0]?.index || 0, r().syncOnChange && e.on(`change`, l), r().syncOnClick && e.on(`click`, d), r().syncOnHover && e.getViewport()?.addEventListener(`mouseover`, f), a())
            }

            function a() {
                !e || !n || (e.on(`ready`, c), e.on(`refresh`, p), n.on(`change`, u), n.on(`filter`, m))
            }

            function o() {
                e?.off(`ready`, c), e?.off(`refresh`, p), e?.off(`change`, l), e?.off(`click`, d), e?.getViewport()?.removeEventListener(`mouseover`, f), n?.off(`change`, u), n?.off(`filter`, m), n = void 0
            }

            function s() {
                let t = r().target;
                e && t && i(t)
            }

            function c() {
                h()
            }

            function l() {
                if (e && n) {
                    let t = e.getPage()?.slides || [],
                        r = n.getPageIndex(t[0].index || 0);
                    r > -1 && n.goTo(r, e.hasNavigated() ? void 0 : {
                        tween: !1,
                        transition: !1
                    }), h()
                }
            }

            function u() {
                if (e && n) {
                    let t = e.getPageIndex(n.getPage()?.slides[0].index || 0);
                    t > -1 && e.goTo(t, n.hasNavigated() ? void 0 : {
                        tween: !1,
                        transition: !1
                    }), h()
                }
            }

            function d(t, r) {
                if (!e || !n || e.getTween()?.isRunning()) return;
                let i = e?.getOptions().classes.slide;
                if (!i) return;
                let a = r.target.closest(`.${i}`);
                if (a) {
                    let e = parseInt(a.getAttribute(`index`) || ``) || 0,
                        t = n.getPageIndex(e);
                    n.goTo(t)
                }
            }

            function f(t) {
                e && d(e, t)
            }

            function p() {
                if (e && n) {
                    let t = e.getPageIndex(n.getPage()?.slides[0].index || 0);
                    t > -1 && e.goTo(t, {
                        tween: !1,
                        transition: !1
                    }), h()
                }
            }

            function m(t, r) {
                e && n && (e.filter(r), u())
            }

            function h() {
                if (!n) return;
                let t = n.getPage()?.slides[0]?.index || 0;
                for (let n of e?.getSlides() || []) n.el?.classList.toggle(`is-selected`, n.index === t)
            }
            return {
                init: function(t) {
                    e = t, e.on(`initSlides`, s)
                },
                destroy: function() {
                    o(), e?.off(`initSlides`, s), e = void 0
                },
                getTarget: function() {
                    return n
                }
            }
        },
        xe = {
            showLoading: !0,
            preload: 1
        },
        Se = `is-lazyloading`,
        Ce = `is-lazyloaded`,
        we = `has-lazyerror`,
        q = () => {
            let e;

            function n() {
                let n = e?.getOptions().Lazyload;
                return t(n) ? {
                    ...xe,
                    ...n
                } : xe
            }

            function r(t) {
                let r = t.el;
                if (!r) return;
                let i = n(),
                    a = `[data-lazy-src],[data-lazy-srcset],[data-lazy-bg]`,
                    o = Array.from(r.querySelectorAll(a));
                r.matches(a) && o.push(r);
                for (let n of o) {
                    let r = n.dataset.lazySrc,
                        a = n.dataset.lazySrcset,
                        o = n.dataset.lazySizes,
                        s = n.dataset.lazyBg,
                        c = (n instanceof HTMLImageElement || n instanceof HTMLSourceElement) && (r || a),
                        l = !!s;
                    if (!(c || l)) continue;
                    let u = r || a || s;
                    if (u) {
                        if (c) {
                            let s = n.parentElement?.classList.contains(`f-panzoom__wrapper`);
                            i.showLoading && e?.showLoading(t), n.addEventListener(`load`, () => {
                                e?.hideLoading(t), p(n, we), n instanceof HTMLImageElement ? n.decode().finally(() => {
                                    p(n, Se), f(n, Ce)
                                }).catch(() => void 0) : (p(n, Se), f(n, Ce)), s || e?.emit(`lazyLoad:loaded`, t, n, u)
                            }), n.addEventListener(`error`, () => {
                                e?.hideLoading(t), p(n, Se), f(n, we), s || e?.emit(`lazyLoad:error`, t, n, u)
                            }), n.classList.add(`f-lazyload`), n.classList.add(Se), s || e?.emit(`lazyLoad:load`, t, n, u), r && (n.src = r), a && (n.srcset = a), o && (n.sizes = o)
                        } else l && (n.style.backgroundImage = `url('${s}')`);
                        delete n.dataset.lazySrc, delete n.dataset.lazySrcset, delete n.dataset.lazySizes, delete n.dataset.lazyBg
                    }
                }
            }

            function i() {
                if (!e) return;
                let t = [...e.getVisibleSlides()],
                    i = n().preload;
                if (i > 0) {
                    let n = e.getPosition(),
                        r = e.getViewportDim();
                    t.push(...e.getVisibleSlides(n + r * i), ...e.getVisibleSlides(n - r * i))
                }
                for (let e of t) r(e)
            }
            return {
                init: function(t) {
                    e = t, e.on(`render`, i)
                },
                destroy: function() {
                    e?.off(`render`, i), e = void 0
                }
            }
        },
        Te = {
            prevTpl: `<svg width="24" height="24" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"></path></svg>`,
            nextTpl: `<svg width="24" height="24" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg>`
        },
        Ee = () => {
            let e;

            function n() {
                let n = e?.getOptions().Arrows;
                return t(n) ? {
                    ...Te,
                    ...n
                } : Te
            }
            let r, a;

            function o() {
                if (!e) return;
                let t = e.getViewport();
                t && (r || (r = s(`prev`), r && t.insertAdjacentElement(`beforebegin`, r)), a || (a = s(`next`), a && t.insertAdjacentElement(`afterend`, a)), m(e.getContainer(), `has-arrows`, !0))
            }

            function s(t) {
                let r = n(),
                    a = `<button data-carousel-go-${t} tabindex="0" class="f-button is-arrow is-${t}" title="{{${t.toUpperCase()}}}">` + r[`${t}Tpl`] + `</button>`,
                    o = i(e.localize(a)) || void 0;
                return o && f(o, r[`${t}Class`]), o
            }

            function c() {
                r?.remove(), r = void 0, a?.remove(), a = void 0, e?.getContainer()?.classList.remove(`has-arrows`)
            }

            function l() {
                e && (r?.toggleAttribute(`aria-disabled`, !e.canGoPrev()), a?.toggleAttribute(`aria-disabled`, !e.canGoNext()))
            }

            function u() {
                e && e.getOptions().Arrows !== !1 && e.getPages().length > 1 ? (o(), l()) : c()
            }
            return {
                init: function(t) {
                    e = t.on([`change`, `refresh`], u)
                },
                destroy: function() {
                    c(), e?.off([`change`, `refresh`], u), e = void 0
                }
            }
        },
        De = `<circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/>`,
        Oe = `<g><line x1="11" y1="8" x2="11" y2="14"></line></g>` + De,
        ke = {
            moveLeft: [`moveLeft`, `MOVE_LEFT`, `<path d="M5 12h14M5 12l6 6M5 12l6-6"/>`],
            moveRight: [`moveRight`, `MOVE_RIGHT`, `<path d="M5 12h14M13 18l6-6M13 6l6 6"/>`],
            moveUp: [`moveUp`, `MOVE_UP`, `<path d="M12 5v14M18 11l-6-6M6 11l6-6"/>`],
            moveDown: [`moveDown`, `MOVE_DOWN`, `<path d="M12 5v14M18 13l-6 6M6 13l6 6"/>`],
            zoomOut: [`zoomOut`, `ZOOM_OUT`, De],
            zoomIn: [`zoomIn`, `ZOOM_IN`, Oe],
            toggleFull: [`toggleFull`, `TOGGLE_FULL`, Oe],
            iterateZoom: [`iterateZoom`, `ITERATE_ZOOM`, Oe],
            toggle1to1: [`toggleFull`, `TOGGLE_FULL`, `<path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/>`],
            rotateCCW: [`rotateCCW`, `ROTATE_CCW`, `<path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/>`],
            rotateCW: [`rotateCW`, `ROTATE_CW`, `<path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/>`],
            flipX: [`flipX`, `FLIP_X`, `<path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/>`],
            flipY: [`flipY`, `FLIP_Y`, `<path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/>`],
            reset: [`reset`, `RESET`, `<path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/>`],
            toggleFS: [`toggleFS`, `TOGGLE_FS`, `<g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g>`]
        },
        Ae = {};
    for (let e of Object.keys(ke)) {
        let t = ke[e];
        Ae[e] = {
            tpl: `<button data-panzoom-action="${t[0]}" class="f-button" title="{{${t[1]}}}"><svg>${t[2]}</svg></button>`
        }
    }
    let J = function(e) {
            return e.Left = `left`, e.middle = `middle`, e.right = `right`, e
        }({}),
        Y = {
            counter: {
                tpl: `<div class="f-counter"><span data-carousel-page></span>/<span data-carousel-pages></span></div>`
            },
            download: {
                tpl: `<button data-carousel-download class="f-button" title="{{DOWNLOAD}}"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></button>`
            },
            autoplay: {
                tpl: `<button data-autoplay-action="toggle" class="f-button" title="{{TOGGLE_AUTOPLAY}}"><svg><g><path d="M5 3.5 19 12 5 20.5Z"/></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>`
            },
            thumbs: {
                tpl: `<button data-thumbs-action="toggle" class="f-button" title="{{TOGGLE_THUMBS}}"><svg><rect width="18" height="14" x="3" y="3" rx="2"/><path d="M4 21h1M9 21h1M14 21h1M19 21h1"/></svg></button>`
            },
            ...Ae
        },
        je = {
            absolute: !1,
            display: {
                left: [],
                middle: [`zoomIn`, `zoomOut`, `toggle1to1`, `rotateCCW`, `rotateCW`, `flipX`, `flipY`, `reset`],
                right: []
            },
            enabled: `auto`,
            items: {}
        },
        Me = () => {
            let e, r;

            function a(n) {
                let r = e?.getOptions().Toolbar,
                    i = (t(r) ? {
                        ...je,
                        ...r
                    } : je)[n];
                return i && typeof i == `function` && e ? i(e) : i
            }

            function o() {
                if (!e || r || e?.getOptions().Toolbar === !1) return;
                let o = e.getContainer();
                if (!o) return;
                let s = a(`enabled`);
                if (!s) return;
                let l = a(`absolute`),
                    u = e.getSlides().length > 1,
                    d = !1,
                    p = !1;
                for (let t of e.getSlides()) t.panzoomRef && (d = !0), (t.downloadSrc || t.type === `image` && t.src) && (p = !0);
                let m = e.getPlugins().Thumbs?.isEnabled() || !1,
                    h = u && e.getPlugins().Autoplay || !1,
                    g = e.getPlugins().Fullscreen && (document.fullscreenEnabled || document.webkitFullscreenEnabled);
                if (s === `auto` && (s = d), !s) return;
                r = o.querySelector(`.f-carousel__toolbar`) || void 0, r || (r = document.createElement(`div`), f(r, `f-carousel__toolbar`));
                let _ = a(`display`),
                    v = c({}, Y, a(`items`));
                for (let a of [`left`, `middle`, `right`]) {
                    let o = _[a] || [],
                        s = document.createElement(`div`);
                    f(s, `f-carousel__toolbar__column is-${a}`);
                    for (let r of o) {
                        let a;
                        if (n(r)) {
                            if (r === `counter` && !u || r === `autoplay` && !h || Ae[r] && !d || r === `fullscreen` && !g || r === `thumbs` && !m || r === `download` && !p) continue;
                            a = v[r]
                        }
                        if (t(r) && (a = r), a && a.tpl) {
                            let t = e.localize(a.tpl);
                            t = t.split(`<svg>`).join(`<svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24">`);
                            let n = i(t);
                            n && (typeof a.click == `function` && e && n.addEventListener(`click`, t => {
                                t.preventDefault(), t.stopPropagation(), typeof a.click == `function` && e && a.click(e, t)
                            }), s.append(n))
                        }
                    }
                    r.append(s)
                }
                if (r.childElementCount) {
                    if (l && f(r, `is-absolute`), !r.parentElement) {
                        let e = a(`parentEl`);
                        e ? e.insertAdjacentElement(`afterbegin`, r) : o.insertAdjacentElement(`afterbegin`, r)
                    }
                    o.contains(r) && (f(o, `has-toolbar`), l && f(o, `has-absolute-toolbar`))
                }
            }
            return {
                init: function(t) {
                    e = t, e?.on(`initSlides`, o)
                },
                destroy: function() {
                    e?.off(`initSlides`, o), p(e?.getContainer(), `has-toolbar has-absolute-toolbar`), r?.remove(), r = void 0
                },
                add: function(e, t) {
                    Y[e] = t
                },
                isEnabled: function() {
                    return !!r
                }
            }
        },
        Ne = {
            autoStart: !0,
            pauseOnHover: !0,
            showProgressbar: !0,
            timeout: 2e3
        },
        Pe = () => {
            let e, n, r = !1,
                i = !1,
                a = !1,
                o = null;

            function s(n) {
                let r = e?.getOptions().Autoplay,
                    i = (t(r) ? {
                        ...Ne,
                        ...r
                    } : Ne)[n];
                return i && typeof i == `function` && e ? i(e) : i
            }

            function c() {
                let t = e?.getPage()?.slides || [];
                for (let e of t)
                    if (e.state === 0) return !0;
                return !1
            }

            function l() {
                clearTimeout(n), n = void 0
            }

            function u() {
                if (!e || !r || a || i || n || !e.isSettled() || c()) return;
                m();
                let t = s(`timeout`);
                n = setTimeout(() => {
                    if (!(!e || !r || i)) {
                        if (!e.isInfinite() && e.getPageIndex() === e.getPages().length - 1) {
                            e.goTo(0);
                            return
                        }
                        e.next()
                    }
                }, t)
            }

            function d() {
                if (!e || e.getPages().length < 2 || e.getOptions().Autoplay === !1 || r) return;
                r = !0, e.emit(`autoplay:start`, s(`timeout`)), f(e.getContainer(), `has-autoplay`), e.getTween()?.on(`start`, x);
                let t = e?.getContainer();
                t && s(`pauseOnHover`) && matchMedia(`(hover: hover)`).matches && (t.addEventListener(`mouseenter`, S, !1), t.addEventListener(`mouseleave`, C, !1)), e.on(`change`, y), e.on(`settle`, b), e.on(`contentReady`, _), e.on(`panzoom:touchStart`, p), e.on(`panzoom:wheel`, p), e.isSettled() && u()
            }

            function p() {
                if (l(), h(), e) {
                    if (r) {
                        e.emit(`autoplay:end`), e.getTween()?.off(`start`, x);
                        let t = e.getContainer();
                        t && (t.classList.remove(`has-autoplay`), t.removeEventListener(`mouseenter`, S, !1), t.removeEventListener(`mouseleave`, C, !1))
                    }
                    e.off(`change`, y), e.off(`settle`, b), e.off(`contentReady`, _), e.off(`panzoom:touchStart`, p), e.off(`panzoom:wheel`, p)
                }
                r = !1, i = !1
            }

            function m() {
                if (!e || (h(), !s(`showProgressbar`))) return;
                let t = s(`progressbarParentEl`);
                if (!t && e.getPlugins().Toolbar?.isEnabled() && (t = e.getContainer()), !t && e.getPlugins().Toolbar?.isEnabled() !== !0) {
                    let n = e.getPages()[0]?.slides || [],
                        r = e.getPage()?.slides || [];
                    n.length === 1 && r.length === 1 && (t = r[0].el)
                }
                if (t ||= e.getViewport(), !t) return;
                o = document.createElement(`div`), f(o, `f-progressbar`), t.prepend(o);
                let n = s(`timeout`) || 1e3;
                o.style.animationDuration = `${n}ms`
            }

            function h() {
                o &&= (o.remove(), null)
            }

            function g() {
                e && e.getPages().length > 1 && s(`autoStart`) && d()
            }

            function _() {
                u()
            }

            function v(e, t) {
                let n = t.target;
                !n || t.defaultPrevented || n.dataset.autoplayAction === `toggle` && w.toggle()
            }

            function y() {
                !e || !e?.isInfinite() && e.getPageIndex() === e.getPages().length - 1 ? p() : (l(), h())
            }

            function b() {
                u()
            }

            function x() {
                l(), h()
            }

            function S() {
                a = !0, r && (l(), h())
            }

            function C() {
                a = !1, r && !i && e?.isSettled() && u()
            }
            let w = {
                init: function(t) {
                    e = t, e.on(`ready`, g), e.on(`click`, v)
                },
                destroy: function() {
                    p(), e?.off(`ready`, g), e?.off(`click`, v), e = void 0
                },
                isEnabled() {
                    return r
                },
                pause: function() {
                    i = !0, l(), h()
                },
                resume: function() {
                    i = !1, r && !a && u()
                },
                start() {
                    d()
                },
                stop() {
                    p()
                },
                toggle() {
                    r ? p() : d()
                }
            };
            return w
        },
        Fe = {
            Carousel: {
                Lazyload: {
                    showLoading: !1
                }
            },
            minCount: 2,
            showOnStart: !0,
            thumbTpl: `<button aria-label="Slide to #{{page}}"><img draggable="false" alt="{{alt}}" data-lazy-src="{{src}}" /></button>`,
            type: `modern`
        },
        Ie, Le = () => {
            let e, n, r, a, o = 0,
                s = 0,
                l = !0,
                d;

            function p(n) {
                let r = e?.getOptions().Thumbs,
                    i = (t(r) ? {
                        ...Fe,
                        ...r
                    } : Fe)[n];
                return i && typeof i == `function` && e ? i(e) : i
            }

            function m() {
                if (!e || e?.getOptions().Thumbs === !1) return !1;
                let t = 0;
                for (let n of e.getSlides()) n.thumbSrc && t++;
                return t >= p(`minCount`)
            }

            function h() {
                return p(`type`) === `modern`
            }

            function g() {
                return p(`type`) === `scrollable`
            }

            function _() {
                let t = [],
                    n = e?.getSlides() || [];
                for (let e of n) t.push({
                    index: e.index,
                    class: e.thumbClass,
                    html: v(e)
                });
                return t
            }

            function v(e) {
                let t = e.thumb ? e.thumb instanceof HTMLImageElement ? e.thumb.src : e.thumb : e.thumbSrc || void 0,
                    n = e.thumbAlt === void 0 ? `Thumbnail #${(e.index||0)+1}` : e.thumbAlt + ``,
                    r = p(`thumbTpl`);
                return r = ge(r, `{{alt}}`, n), r = ge(r, `{{src}}`, t + ``), r = ge(r, `{{index}}`, `${e.index||0}`), r = ge(r, `{{page}}`, `${(e.index||0)+1}`), r
            }

            function y(e) {
                return `<div index="${e.index||0}" class="f-thumbs__slide ${e.class||``}">${e.html||``}</div>`
            }

            function b(t = !1) {
                let n = e?.getContainer();
                if (!e || !n || r || !m()) return;
                let i = p(`Carousel`)?.classes || {};
                if (i.container = i.container || `f-thumbs`, !r) {
                    let e = n.nextElementSibling;
                    e?.classList.contains(i.container) && (r = e)
                }
                if (!r) {
                    r = document.createElement(`div`);
                    let e = p(`parentEl`);
                    e ? e.insertAdjacentElement(`beforeend`, r) : n.insertAdjacentElement(`afterend`, r)
                }
                f(r, i.container), f(r, `f-thumbs`), f(r, `is-${p(`type`)}`), t && f(r, `is-hidden`)
            }

            function x() {
                if (!r || !g()) return;
                a = document.createElement(`div`), f(a, `f-thumbs__viewport`);
                let t = ``;
                for (let e of _()) typeof(e.html || ``) == `string` && (t += y(e));
                a.innerHTML = t, r.append(a), r.addEventListener(`click`, t => {
                    t.preventDefault();
                    let n = t.target.closest(`[index]`),
                        r = parseInt(n?.getAttribute(`index`) || `-1`);
                    e && r > -1 && e.goTo(r)
                }), d = new IntersectionObserver(e => {
                    e.forEach(e => {
                        e.isIntersecting && e.target instanceof HTMLImageElement && (e.target.src = e.target.getAttribute(`data-lazy-src`) + ``, e.target.removeAttribute(`data-lazy-src`), d?.unobserve(e.target))
                    })
                }, {
                    root: a,
                    rootMargin: `100px`
                }), r.querySelectorAll(`[data-lazy-src]`).forEach(e => {
                    d?.observe(e)
                }), e?.emit(`thumbs:ready`)
            }

            function S() {
                if (!Ie || !e || !r || g() || n) return;
                let t = _();
                if (!t.length) return;
                let i = c({}, {
                    Sync: {
                        target: e
                    },
                    Lazyload: {
                        preload: 1
                    },
                    slides: t,
                    classes: {
                        container: `f-thumbs`,
                        viewport: `f-thumbs__viewport`,
                        slide: `f-thumbs__slide`
                    },
                    center: !0,
                    fill: !h(),
                    infinite: !1,
                    dragFree: !0,
                    rtl: e.getOptions().rtl || !1,
                    slidesPerPage: e => {
                        let t = 0;
                        return h() && (ee(), t = (o - s) * 4), e && e.getTotalSlideDim() <= e.getViewportDim() - t ? 1 / 0 : 1
                    }
                }, Fe.Carousel || {}, p(`Carousel`) || {});
                n = Ie(r, i, {
                    Sync: be,
                    Lazyload: q
                }), n.on(`ready`, () => {
                    f(r, `is-syncing`), e?.emit(`thumbs:ready`), h() && e?.on(`render`, D)
                }), n.on(`destroy`, () => {
                    e?.emit(`thumbs:destroy`)
                }), n.init(), n.getGestures()?.on(`start`, () => {
                    l = !1
                }), n.on(`click`, (e, t) => {
                    let n = t.target;
                    if (n) {
                        let e = n.matches(`button`) ? n : n.firstElementChild;
                        e && e.matches(`button`) && (t.preventDefault(), e.focus({
                            preventScroll: !0
                        }))
                    }
                }), f(e.getContainer(), `has-thumbs`), F()
            }

            function C() {
                r || (b(!0), x(), S()), r && r.classList.toggle(`is-hidden`)
            }

            function w() {
                m() && p(`showOnStart`) && (b(), x())
            }

            function T() {
                m() && (S(), e?.on(`addSlide`, k), e?.on(`removeSlide`, A), e?.on(`click`, j), e?.on(`refresh`, M), e?.getGestures()?.on(`start`, E), N(!0))
            }

            function E() {
                l = !0, document.activeElement?.closest(`.f-thumbs`) && document.activeElement?.blur()
            }

            function D() {
                r?.classList.toggle(`is-syncing`, e?.hasNavigated() === !1 || e?.getTween()?.isRunning()), F(), e?.getGestures()?.isPointerDown() && P()
            }

            function O() {
                l = !0, N()
            }

            function k(e, t) {
                let r = {
                    html: v(t)
                };
                if (n) n.add(r, t.index);
                else if (a) {
                    let e = i(y(r));
                    if (e) {
                        a.append(e);
                        let t = e.querySelector(`img`);
                        t && d?.observe(t)
                    }
                }
            }

            function A(e, t) {
                n ? n.remove(t.index) : a && a.querySelector(`[index="${t.index}"]`)?.remove()
            }

            function j(e, t) {
                let n = t.target;
                !t.defaultPrevented && n?.dataset?.thumbsAction === `toggle` && C()
            }

            function M() {
                N()
            }

            function N(t = !1) {
                if (!e || !a || !g()) return;
                let n = e.getPageIndex();
                a.querySelectorAll(`.is-selected`).forEach(e => {
                    e.classList.remove(`is-selected`)
                });
                let r = a.querySelector(`[index="${n}"]`);
                if (r) {
                    r.classList.add(`is-selected`);
                    let e = a.getBoundingClientRect(),
                        n = r.getBoundingClientRect(),
                        i = r.offsetTop - a.offsetTop - e.height * .5 + n.height * .5,
                        o = r.scrollLeft - a.scrollLeft - e.width * .5 + n.width * .5;
                    a.scrollTo({
                        top: i,
                        left: o,
                        behavior: t ? `instant` : `smooth`
                    })
                }
            }

            function ee() {
                if (!h() || !r) return;
                let e = e => r && parseFloat(getComputedStyle(r).getPropertyValue(`--f-thumb-` + e)) || 0;
                o = e(`width`), s = e(`clip-width`)
            }

            function P() {
                if (!h() || !e || !n || !l) return;
                let t = n.getTween(),
                    r = n.getPages(),
                    i = e.getPageIndex() || 0,
                    a = e.getPageProgress() || 0;
                if (!e || !r || !r[i] || !t) return;
                let c = t.isRunning() ? t.getCurrentValues().pos : n.getPosition();
                if (c === void 0) return;
                let d = r[i].pos + a * (o - s);
                d = u(r[0].pos, d, r[r.length - 1].pos), t.from({
                    pos: c
                }).to({
                    pos: d
                }).start()
            }

            function F() {
                if (!h() || !e || !n) return;
                let t = n?.getSlides() || [],
                    r = o * -.5;
                for (let n of t) {
                    let t = n.el;
                    if (!t) continue;
                    let i = e.getPageProgress(n.index) || 0;
                    i = Math.max(-1, Math.min(1, i)), i > -1 && i < 1 && (r += o * .5 * (1 - Math.abs(i))), i = Math.round(i * 1e4) / 1e4, r = Math.round(r * 1e4) / 1e4, t.style.setProperty(`--progress`, `${Math.abs(i)}`), t.style.setProperty(`--shift`, `${e?.isRTL()?r*-1:r}px`), i > -1 && i < 1 && (r += o * .5 * (1 - Math.abs(i)))
                }
            }
            return {
                init: function(t, n) {
                    Ie = n, e = t, e.on(`ready`, T), e.on(`initSlides`, w), e.on(`change`, O)
                },
                destroy: function() {
                    g() && e?.emit(`thumbs:destroy`), e?.off(`ready`, T), e?.off(`initSlides`, w), e?.off(`change`, O), e?.off(`render`, D), e?.off(`addSlide`, k), e?.off(`click`, j), e?.off(`refresh`, M), e?.getGestures()?.off(`start`, E), e?.getContainer()?.classList.remove(`has-thumbs`), e = void 0, n?.destroy(), n = void 0, r?.remove(), r = void 0
                },
                getCarousel: function() {
                    return n
                },
                getContainer: function() {
                    return r
                },
                getType: function() {
                    return p(`type`)
                },
                isEnabled: m
            }
        },
        Re = {
            autosize: !1,
            iframeAttr: {
                allow: `autoplay; fullscreen`,
                scrolling: `auto`
            },
            preload: !1
        },
        ze = () => {
            let e;

            function r() {
                let n = e?.getOptions().Html;
                return t(n) ? c({}, Re, n) : Re
            }

            function i() {
                return e?.getOptions().Html !== !1
            }

            function a(e) {
                return e.type === `iframe` || e.type === `pdf` || e.type === `gmap`
            }

            function o(e) {
                let t = `${e}`;
                return t.match(/^\d+$/) ? `${t}px` : t
            }

            function s(e) {
                if (e === void 0 || e === ``) return;
                let t = `${e}`.trim();
                if (!t.match(/^\d+(\.\d+)?(px)?$/)) return;
                let n = parseFloat(t);
                return Number.isFinite(n) ? n : void 0
            }

            function l(e, t) {
                let n = e[t] ?? r()[t];
                return n === `true` ? !0 : n === `false` ? !1 : n
            }

            function u(e, t) {
                if (!i()) return;
                let r = t.type,
                    a = t.src;
                if (!(r || !n(a))) {
                    if (a.charAt(0) === `#` ? r = `inline` : a.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.((a)?png|avif|gif|jp(g|eg)|pjp(eg)?|jfif|svg|webp|bmp|ico|tif(f)?)((\?|#).*)?$)/i) ? r = `image` : a.match(/\.(pdf)((\?|#).*)?$/i) ? r = `pdf` : a.match(/\.(html|php)((\?|#).*)?$/i) && (r = `iframe`), !r) {
                        let e = a.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+\.?\d+?)z))|(?:\?ll=))(.*)?/i);
                        e && (a = `https://maps.google.${e[1]}/?ll=${(e[2]?e[2]+`&z=`+Math.floor(parseFloat(e[3]))+(e[4]?e[4].replace(/^\//,`&`):``):e[4]+``).replace(/\?/,`&`)}&output=${e[4]&&e[4].indexOf(`layer=c`)>0?`svembed`:`embed`}`, r = `gmap`)
                    }
                    if (!r) {
                        let e = a.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i);
                        e && (a = `https://maps.google.${e[1]}/maps?q=${e[2].replace(`query=`,`q=`).replace(`api=1`,``)}&output=embed`, r = `gmap`)
                    }
                    r && (t.src = a, t.type = r)
                }
            }

            function d(e, t) {
                i() && a(t) && _(t)
            }

            function m(t, n) {
                if (a(n)) {
                    let t = n.el;
                    e?.hideError(n), n.contentEl?.remove(), n.contentEl = void 0, n.htmlEl?.remove(), n.htmlEl = void 0, t && (p(t, `has-html has-iframe has-pdf has-gmap`), p(t, `is-loading`))
                }
            }

            function h() {
                for (let t of e?.getSlides() || []) a(t) && (g(t), t.state === le.Loaded && v(t))
            }

            function g(e) {
                let t = e.htmlEl;
                if (!(!t || !a(e)) && (t.style.aspectRatio = ``, t.style.width = ``, t.style.height = ``, t.style.maxWidth = ``, t.style.maxHeight = ``, e.width && (t.style.maxWidth = o(e.width)), e.height && (t.style.maxHeight = o(e.height)), e.aspectRatio)) {
                    let n = e.aspectRatio.split(`/`),
                        r = parseFloat(n[0].trim()),
                        i = n[1] ? parseFloat(n[1].trim()) : 0,
                        a = r && i ? r / i : r;
                    t.offsetHeight;
                    let o = t.getBoundingClientRect(),
                        s = a < (o.width || 1) / (o.height || 1);
                    t.style.aspectRatio = `${e.aspectRatio}`, t.style.width = s ? `auto` : ``, t.style.height = s ? `` : `auto`
                }
            }

            function _(t) {
                let n = t.el,
                    i = t.src;
                if (!e || !n || !i) return;
                let a = document.createElement(`iframe`);
                f(a, `f-iframe`);
                for (let [e, t] of Object.entries(r().iframeAttr || {})) a.setAttribute(e, t);
                a.onerror = () => {
                    t.state = le.Error, e?.showError(t, `{{IFRAME_ERROR}}`)
                };
                let o = document.createElement(`div`);
                f(o, `f-html`), o.append(a), t.htmlEl = o, t.contentEl = a, f(n, `has-html has-iframe has-${t.type}`), n.prepend(o), g(t);
                let s = l(t, `preload`),
                    c = l(t, `autosize`);
                t.type === `iframe` && (s || c) ? (t.state = le.Loading, e.showLoading(t), f(n, `is-loading`), a.onload = () => {
                    if (!e || e.getState() === 2 || !a.src.length || t.contentEl !== a || !a.isConnected) return;
                    t.state = le.Loaded;
                    let r = a.dataset.ready !== `true`;
                    a.dataset.ready = `true`, v(t), e.hideLoading(t), r && e.emit(`contentReady`, t), p(n, `is-loading`)
                }, a.src = `${i}`) : (a.src = `${i}`, e.emit(`contentReady`, t))
            }

            function v(e) {
                let t = e.contentEl,
                    n = t?.parentElement,
                    r = n?.style,
                    i = l(e, `autosize`),
                    a = s(e.width) || 0,
                    o = s(e.height) || 0;
                if (a && o && (i = !1), !(!t || !n || !r || !i)) {
                    try {
                        let e = window.getComputedStyle(n),
                            i = parseFloat(e.paddingLeft) + parseFloat(e.paddingRight),
                            s = parseFloat(e.paddingTop) + parseFloat(e.paddingBottom),
                            c = t.contentWindow;
                        if (c) {
                            let e = c.document,
                                t = e.getElementsByTagName(`html`)[0],
                                n = e.body;
                            r.width = ``;
                            let l = window.getComputedStyle(n),
                                u = parseFloat(l.marginLeft) + parseFloat(l.marginRight),
                                d = n.style.overflow || ``;
                            n.style.overflow = `hidden`, a ||= n.scrollWidth + u + i, r.flex = `0 0 auto`, r.width = `${a}px`, r.height = `${n.scrollHeight}px`, n.style.overflow = d, o = Math.max(t.scrollHeight, Math.ceil(t.getBoundingClientRect().height)) + s
                        }
                    } catch {}(a || o) && Object.assign(r, {
                        flex: `0 1 auto`,
                        width: a ? `${a}px` : ``,
                        height: o ? `${o}px` : ``
                    })
                }
            }
            return {
                init: function(t) {
                    e = t, e.on(`addSlide`, u), e.on(`attachSlideEl`, d), e.on(`detachSlideEl`, m), e.on(`refresh`, h)
                },
                destroy: function() {
                    e?.off(`addSlide`, u), e?.off(`attachSlideEl`, d), e?.off(`detachSlideEl`, m), e?.off(`refresh`, h), e = void 0
                }
            }
        },
        Be = (e, t = {}) => {
            let n = new URL(e),
                r = new URLSearchParams(n.search),
                i = new URLSearchParams;
            for (let [e, n] of [...r, ...Object.entries(t)]) {
                let t = n + ``;
                if (e === `t`) {
                    let e = t.match(/((\d*)m)?(\d*)s?/);
                    e && i.set(`start`, parseInt(e[2] || `0`) * 60 + parseInt(e[3] || `0`) + ``)
                } else i.set(e, t)
            }
            let a = i + ``,
                o = e.match(/#t=((.*)?\d+s)/);
            return o && (a += `#t=${o[1]}`), a
        },
        Ve = {
            autoplay: !1,
            html5videoTpl: `<video class="f-html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">
    <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn't support embedded videos.</video>`,
            iframeAttr: {
                allow: `autoplay; fullscreen`,
                scrolling: `no`,
                referrerPolicy: `strict-origin-when-cross-origin`,
                credentialless: ``
            },
            vimeo: {
                byline: 1,
                color: `00adef`,
                controls: 1,
                dnt: 1,
                muted: 0
            },
            youtube: {
                controls: 1,
                enablejsapi: 1,
                nocookie: 1,
                rel: 0,
                fs: 1
            }
        },
        He = () => {
            let e, r = !1;

            function a() {
                let n = e?.getOptions().Video;
                return t(n) ? {
                    ...Ve,
                    ...n
                } : Ve
            }

            function o() {
                return e?.getPage()?.slides[0]
            }
            let s = t => {
                try {
                    let n = JSON.parse(t.data);
                    if (t.origin === `https://player.vimeo.com`) {
                        if (n.event === `ready`)
                            for (let n of Array.from(e?.getContainer()?.getElementsByClassName(`f-iframe`) || [])) n instanceof HTMLIFrameElement && n.contentWindow === t.source && (n.dataset.ready = `true`)
                    } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && n.event === `onReady`) {
                        let e = document.getElementById(n.id);
                        e && (e.dataset.ready = `true`)
                    }
                } catch {}
            };

            function c() {
                let e = o(),
                    t = e?.el;
                if (t && e?.type === `html5video`) try {
                    let e = t.querySelector(`video`);
                    if (e) {
                        let t = e.play();
                        t !== void 0 && t.then(() => {}).catch(t => {
                            e.muted = !0, e.play()
                        })
                    }
                } catch {}
                let n = e?.htmlEl;
                n instanceof HTMLIFrameElement && n.contentWindow?.postMessage(`{"event":"command","func":"stopVideo","args":""}`, `*`)
            }

            function l() {
                let e = o(),
                    t = e?.type;
                if (!(e?.el && (t === `youtube` || t === `vimeo`))) return;
                let n = () => {
                    if (e.contentEl && e.contentEl instanceof HTMLIFrameElement && e.contentEl.contentWindow) {
                        let t;
                        if (e.contentEl.dataset.ready === `true`) {
                            t = e.type === `youtube` ? {
                                event: `command`,
                                func: `playVideo`
                            } : {
                                method: `play`,
                                value: `true`
                            }, t && e.contentEl.contentWindow.postMessage(JSON.stringify(t), `*`), e.poller = void 0;
                            return
                        }
                        e.type === `youtube` && (t = {
                            event: `listening`,
                            id: e.contentEl.getAttribute(`id`)
                        }, e.contentEl.contentWindow.postMessage(JSON.stringify(t), `*`))
                    }
                    e.poller = setTimeout(n, 250)
                };
                n()
            }

            function u(t) {
                let r = t.el,
                    o = t.src;
                if (!e || !r || !o) return;
                let s = t.html5videoTpl || a().html5videoTpl,
                    c = t.html5videoFormat || a().html5videoFormat;
                if (!s) return;
                let l = t.poster || (t.thumb && n(t.thumb) ? t.thumb : ``),
                    u = i(s.replace(/\{\{src\}\}/gi, o + ``).replace(/\{\{format\}\}/gi, c || ``).replace(/\{\{poster\}\}/gi, l + ``));
                if (!u) return;
                let d = document.createElement(`div`);
                f(d, `f-html`), d.append(u), t.contentEl = u, t.htmlEl = d, f(r, `has-${t.type}`), r.prepend(d), v(t), e.emit(`contentReady`, t)
            }

            function d(t) {
                let n = t.el,
                    r = t.src;
                if (!e || !n || !r) return;
                let i = document.createElement(`iframe`);
                f(i, `f-iframe`), i.setAttribute(`id`, `f-iframe_${t.videoId}`);
                for (let [e, t] of Object.entries(a().iframeAttr || {})) i.setAttribute(e, t);
                t.type === `youtube` && (i.onload = () => {
                    e?.getState() === 1 && i.contentWindow?.postMessage(JSON.stringify({
                        event: `listening`,
                        id: i.getAttribute(`id`)
                    }), `*`)
                }), i.onerror = () => {
                    e?.showError(t, `{{IFRAME_ERROR}}`)
                };
                let o = document.createElement(`div`);
                f(o, `f-html`), o.append(i), t.contentEl = i, t.htmlEl = o, f(n, `has-html has-iframe has-${t.type}`), i.src = `${t.src}`, n.prepend(o), v(t), e.emit(`contentReady`, t)
            }

            function p(e, t) {
                let r = t.src;
                if (!n(r)) return;
                let i = t.type;
                if (!i || i === `html5video`) {
                    let e = r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i);
                    e && (i = `html5video`, t.html5videoFormat = t.html5videoFormat || `video/` + (e[1] === `ogv` ? `ogg` : e[1]))
                }
                if (!i || i === `youtube`) {
                    let e = r.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i);
                    if (e) {
                        let n = {
                                ...a().youtube,
                                ...t.youtube || {}
                            },
                            o = `www.youtube${n.nocookie?`-nocookie`:``}.com`,
                            s = Be(r, n),
                            c = encodeURIComponent(e[2]);
                        t.videoId = c, t.src = `https://${o}/embed/${c}?${s}`, t.thumb = t.thumb || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, i = `youtube`
                    }
                }
                if (!i || i === `vimeo`) {
                    let e = r.match(/^.+vimeo.com\/(?:\/)?(video\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/);
                    if (e) {
                        let n = Be(r, {
                                ...a().vimeo,
                                ...t.vimeo || {}
                            }),
                            o = encodeURIComponent(e[2]),
                            s = e[5] || ``;
                        t.videoId = o, t.src = `https://player.vimeo.com/video/${o}?${s?`h=${s}${n?`&`:``}`:``}${n}`, i = `vimeo`
                    }
                }
                t.type = i
            }

            function m(e, t) {
                t.type === `html5video` && u(t), (t.type === `youtube` || t.type === `vimeo`) && d(t)
            }

            function h(e, t) {
                (t.type === `html5video` || t.type === `youtube` || t.type === `vimeo`) && (t.contentEl?.remove(), t.contentEl = void 0, t.htmlEl?.remove(), t.htmlEl = void 0), t.poller && clearTimeout(t.poller)
            }

            function g() {
                r = !1
            }

            function _() {
                if (r) return;
                r = !0;
                let e = o();
                (e && e.autoplay !== void 0 ? e.autoplay : a().autoplay) && (c(), l())
            }

            function v(e) {
                let t = e?.htmlEl;
                if (!(!e || !t || !(e.type === `html5video` || e.type === `youtube` || e.type === `vimeo`))) {
                    if (t.style.aspectRatio = ``, t.style.width = ``, t.style.height = ``, t.style.maxWidth = ``, t.style.maxHeight = ``, e.width) {
                        let n = `${e.width}`;
                        n.match(/^\d+$/) && (n += `px`), t.style.maxWidth = `${n}`
                    }
                    if (e.height) {
                        let n = `${e.height}`;
                        n.match(/^\d+$/) && (n += `px`), t.style.maxHeight = `${n}`
                    }
                    if (e.aspectRatio) {
                        let n = e.aspectRatio.split(`/`),
                            r = parseFloat(n[0].trim()),
                            i = n[1] ? parseFloat(n[1].trim()) : 0,
                            a = r && i ? r / i : r;
                        t.offsetHeight;
                        let o = t.getBoundingClientRect(),
                            s = a < (o.width || 1) / (o.height || 1);
                        t.style.aspectRatio = `${e.aspectRatio}`, t.style.width = s ? `auto` : ``, t.style.height = s ? `` : `auto`
                    }
                }
            }

            function y() {
                v(o())
            }
            return {
                init: function(t) {
                    e = t, e.on(`addSlide`, p), e.on(`attachSlideEl`, m), e.on(`detachSlideEl`, h), e.on(`ready`, _), e.on(`change`, g), e.on(`settle`, _), e.on(`refresh`, y), window.addEventListener(`message`, s)
                },
                destroy: function() {
                    e?.off(`addSlide`, p), e?.off(`attachSlideEl`, m), e?.off(`detachSlideEl`, h), e?.off(`ready`, _), e?.off(`change`, g), e?.off(`settle`, _), e?.off(`refresh`, y), window.removeEventListener(`message`, s), e = void 0
                }
            }
        },
        Ue = {
            autoStart: !1,
            btnTpl: `<button data-fullscreen-action="toggle" class="f-button" title="{{TOGGLE_FULLSCREEN}}"><svg><g><path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>`
        },
        We = `in-fullscreen-mode`,
        Ge = () => {
            let e;

            function n(n) {
                let r = e?.getOptions().Fullscreen,
                    i = (t(r) ? {
                        ...Ue,
                        ...r
                    } : Ue)[n];
                return i && typeof i == `function` && e ? i(e) : i
            }

            function r() {
                e?.getPlugins().Toolbar?.add(`fullscreen`, {
                    tpl: n(`btnTpl`)
                })
            }

            function i() {
                if (n(`autoStart`)) {
                    let e = o();
                    e && c(e)
                }
            }

            function a(e, t) {
                let n = t.target;
                !n || t.defaultPrevented || n.dataset.fullscreenAction === `toggle` && u()
            }

            function o() {
                return n(`el`) || e?.getContainer() || void 0
            }

            function s() {
                let e = document;
                return e.fullscreenEnabled ? !!e.fullscreenElement : e.webkitFullscreenEnabled ? !!e.webkitFullscreenElement : !1
            }

            function c(e) {
                let t = document;
                e ||= t.documentElement;
                let n;
                return t.fullscreenEnabled ? n = e.requestFullscreen() : t.webkitFullscreenEnabled && (n = e.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)), n && n.then(() => {
                    e.classList.add(We)
                }), n
            }

            function l() {
                let e = document,
                    t;
                return e.fullscreenEnabled ? t = e.fullscreenElement && e.exitFullscreen() : e.webkitFullscreenEnabled && (t = e.webkitFullscreenElement && e.webkitExitFullscreen()), t && t.then(() => {
                    o()?.classList.remove(We)
                }), t
            }

            function u() {
                if (s()) l();
                else {
                    let e = o();
                    e && c(e)
                }
            }
            return {
                init: function(t) {
                    e = t, e.on(`initPlugins`, r), e.on(`ready`, i), e.on(`click`, a)
                },
                destroy: function() {
                    e?.off(`initPlugins`, r), e?.off(`ready`, i), e?.off(`click`, a)
                },
                exit: l,
                inFullscreen: s,
                request: c,
                toggle: u
            }
        };

    function Ke() {
        if (window.parent === window) return !1;
        try {
            var e = window.frameElement
        } catch {
            e = null
        }
        return e === null ? location.protocol === `data:` : e.hasAttribute(`sandbox`)
    }
    let X, qe = !1,
        Je = !1,
        Ye = !1,
        Xe = !1,
        Ze, Qe = () => {
            let e = new URL(document.URL).hash,
                t = e.slice(1).split(`-`),
                n = t[t.length - 1],
                r = n && /^\+?\d+$/.test(n) && parseInt(t.pop() || `1`, 10) || 1;
            return {
                urlHash: e,
                urlSlug: t.join(`-`),
                urlIndex: r
            }
        },
        $e = () => {
            let e = X?.getInstance(),
                t = e?.getState();
            return !!(e && (t === 0 || t === 1))
        },
        et = () => {
            if (!X || $e()) return;
            let {
                urlSlug: e,
                urlIndex: t
            } = Qe();
            if (!e) return;
            let n = document.querySelector(`[data-slug="${e}"]`);
            n && X.fromTriggerEl(n), $e() || (n = document.querySelectorAll(`[data-fancybox="${e}"]`)[t - 1], n && X.fromTriggerEl(n, {
                startIndex: t - 1
            })), $e() && n && !n.closest(`[inert]`) && n.scrollIntoView({
                behavior: `instant`,
                block: `center`,
                inline: `center`
            })
        },
        tt = e => {
            let n = e.getOptions().Hash,
                r = e.getSlide();
            return r && (r.slug || r.fancybox || (t(n) ? n.slug : ``)) || ``
        },
        nt = e => {
            let t = tt(e),
                n = e.getSlide();
            if (!n || !t) return ``;
            let r = parseInt(n.index + ``, 10) + 1,
                i = n.slug ? `#${n.slug}` : `#${t}-${r}`;
            return (e.getCarousel()?.getPages()?.length || 0) < 2 && (i = `#${t}`), i
        },
        rt = () => {
            if (!X || Ye) return;
            let e = X?.getInstance(),
                n = e?.getCarousel(),
                {
                    urlSlug: r,
                    urlIndex: i
                } = Qe(),
                a = e?.getOptions().Hash;
            if (a !== !1) {
                if (e && e.getState() === 1 && n) {
                    let o = n.getSlides();
                    for (let e of o || [])
                        if (e.slug === r || (e.fancybox === r || t(a) && a.slug === r) && e.index === i - 1) {
                            Je = !1, n.goTo(e.index);
                            return
                        } Xe = !0, e.close(), Xe = !1
                }
                et()
            }
        },
        it = () => {
            X && (Ze = setTimeout(() => {
                qe = !0, et(), qe = !1
            }, 300), window.addEventListener(`hashchange`, rt, !1))
        },
        at;

    function ot() {
        history.scrollRestoration && at && (history.scrollRestoration = at, at = void 0)
    }
    let st = () => {
        let e, t = ``;

        function n() {
            if (!e || !e.isTopMost() || e.getOptions().Hash === !1) return;
            if (qe) {
                let t = e.getOptions().sync;
                t && t.goTo(e?.getCarousel()?.getPageIndex() || 0, {
                    transition: !1,
                    tween: !1
                })
            }
            let n = e.getCarousel();
            if (!n || !e.getSlide()) return;
            let i = tt(e);
            if (!i) return;
            let {
                urlHash: a,
                urlSlug: o
            } = Qe(), s = nt(e);
            a !== s && (t = a), history.scrollRestoration && !at && (at = history.scrollRestoration, history.scrollRestoration = `manual`, window.addEventListener(`beforeunload`, ot)), n.on(`change`, r);
            let c = i !== o;
            try {
                window.history[c ? `pushState` : `replaceState`]({}, document.title, window.location.pathname + window.location.search + s), c && (Je = !0)
            } catch {}
        }

        function r() {
            if (!e || !e.isTopMost() || e.getOptions().Hash === !1 || !e.getSlide() || !tt(e)) return;
            let t = nt(e);
            Ye = !0;
            try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + t)
            } catch {}
            Ye = !1
        }

        function i() {
            if (!(!e || !e.isTopMost() || e.getOptions().Hash === !1 || Xe) && tt(e)) {
                Ye = !0;
                try {
                    Je && !Ke() && document.activeElement?.nodeName !== `IFRAME` ? window.history.back() : window.history.replaceState({}, document.title, window.location.pathname + window.location.search + t)
                } catch {}
                Ye = !1
            }
        }
        return {
            init: function(t) {
                clearTimeout(Ze), e = t, e.on(`ready`, n), e.on(`close`, i)
            },
            destroy: function() {
                e?.off(`ready`, n), e?.off(`close`, i);
                let t = e?.getCarousel();
                t && t.off(`change`, r), e = void 0, X?.getInstance() || (ot(), window.removeEventListener(`beforeunload`, ot))
            }
        }
    };
    st.getInfoFromURL = Qe, st.startFromUrl = et, st.setup = function(e) {
        X || (X = e, l() && (/complete|interactive|loaded/.test(document.readyState) ? it() : document.addEventListener(`DOMContentLoaded`, it)))
    };
    let ct = {
            ...K,
            CLOSE: `Close`,
            NEXT: `Next`,
            PREV: `Previous`,
            MODAL: `You can close this modal content with the ESC key`,
            ELEMENT_NOT_FOUND: `HTML Element Not Found`,
            IFRAME_ERROR: `Error Loading Page`,
            NO_CAPTION: `No Caption`,
            TOGGLE_SIDEBAR: `Toggle sidebar`
        },
        Z = `<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24"><path d="M19.286 4.714 4.714 19.286M4.714 4.714l14.572 14.572" /></svg></button>`;
    Me().add(`close`, {
        tpl: Z
    });
    let lt = e => {
            e.cancelable && e.preventDefault()
        },
        ut = e => {
            let t = e.getBoundingClientRect(),
                n = e.closest(`[style]`),
                r = n?.parentElement;
            if (n && n.style.transform && r) {
                let e = r.getBoundingClientRect();
                if (t.left < e.left || t.left > e.left + e.width - t.width || t.top < e.top || t.top > e.top + e.height - t.height) return !1
            }
            let i = Math.max(document.documentElement.clientHeight, window.innerHeight),
                a = Math.max(document.documentElement.clientWidth, window.innerWidth);
            return !(t.bottom < 0 || t.top - i >= 0 || t.right < 0 || t.left - a >= 0)
        };

    function dt(e) {
        var t = e.getBoundingClientRect();
        return t.bottom > 0 && t.right > 0 && t.left < (window.innerWidth || document.documentElement.clientWidth) && t.top < (window.innerHeight || document.documentElement.clientHeight)
    }
    let ft = (e, t, n, r, i = `contain`) => {
            if (i === `contain` || e > n || t > r) {
                let i = n / e,
                    a = r / t,
                    o = Math.min(i, a);
                e *= o, t *= o
            }
            return {
                width: e,
                height: t
            }
        },
        pt = (e = null, t = ``, n) => {
            if (!e || !e.parentElement || !t) {
                n && n();
                return
            }
            mt(e);
            let r = i => {
                i.target === e && e.dataset.animationName && (e.removeEventListener(`animationend`, r), delete e.dataset.animationName, n && n(), e.classList.remove(t))
            };
            e.dataset.animationName = t, e.addEventListener(`animationend`, r), f(e, t)
        },
        mt = e => {
            e && e.dispatchEvent(new CustomEvent(`animationend`, {
                bubbles: !1,
                cancelable: !0,
                currentTarget: e
            }))
        },
        Q = function(e) {
            return e[e.Init = 0] = `Init`, e[e.Ready = 1] = `Ready`, e[e.Closing = 2] = `Closing`, e[e.Destroyed = 3] = `Destroyed`, e
        }({}),
        ht = {
            ajax: null,
            backdropClick: `close`,
            Carousel: {},
            closeButton: `auto`,
            closeButtonTpl: Z,
            closeExisting: !1,
            delegateEl: void 0,
            dragToClose: !0,
            fadeEffect: !0,
            groupAll: !1,
            groupAttr: `data-fancybox`,
            hideClass: `f-fadeOut`,
            hideScrollbar: !0,
            id: void 0,
            idle: !1,
            keyboard: {
                Escape: `close`,
                Delete: `close`,
                Backspace: `close`,
                PageUp: `next`,
                PageDown: `prev`,
                ArrowUp: `prev`,
                ArrowDown: `next`,
                ArrowRight: `next`,
                ArrowLeft: `prev`
            },
            l10n: ct,
            mainClass: ``,
            mainStyle: {},
            mainTpl: `<dialog class="fancybox__dialog">
    <div class="fancybox__container" tabindex="0" aria-label="{{MODAL}}">
      <div class="fancybox__backdrop"></div>
      <div class="fancybox__carousel"></div>
    </div>
  </dialog>`,
            modal: !0,
            on: {},
            parentEl: void 0,
            placeFocusBack: !0,
            showClass: `f-zoomInUp`,
            startIndex: 0,
            sync: void 0,
            theme: `dark`,
            triggerEl: void 0,
            triggerEvent: void 0,
            zoomEffect: !0
        },
        gt = new Map,
        _t = 0,
        vt = `with-fancybox`,
        yt = () => {
            let e = Q.Init,
                a = {
                    ...ht
                },
                l = -1,
                u = {},
                h = [],
                g, _, v, y, b, x, S, C = !1,
                E = !0,
                D = 0;

            function O(e, ...t) {
                let n = a[e];
                return n && typeof n == `function` ? n(Fe, ...t) : n
            }

            function k(e, t = []) {
                let n = O(`l10n`) || {};
                e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t) => n[t] || e);
                for (let n = 0; n < t.length; n++) e = e.split(t[n][0]).join(t[n][1]);
                return e = e.replace(/\{\{(.*?)\}\}/g, (e, t) => t), e
            }
            let A = new Map;

            function j(e, ...t) {
                let n = [...A.get(e) || []];
                for (let [t, r] of Object.entries(a.on || {}))(t === e || t.split(` `).indexOf(e) > -1) && n.push(r);
                for (let e of n) e && typeof e == `function` && e(Fe, ...t);
                e !== `*` && j(`*`, e, ...t)
            }

            function M(t = [], n = {}) {
                e !== Q.Init && (Fe.destroy(), e = Q.Init), a = c({}, ht, n), l = O(`id`) || `fancybox-${++_t}`;
                let r = gt.get(l);
                if (r && r.destroy(), gt.set(l, Fe), j(`init`), ee(), P(t), F(), L(), !(!g || !_)) {
                    if (O(`closeExisting`))
                        for (let [e, t] of gt.entries()) e !== l && t.close();
                    O(`fadeEffect`) ? (setTimeout(() => {
                        N()
                    }, 500), f(_, `is-revealing`)) : N(), _.classList.add(`is-ready`), e = Q.Ready, j(`ready`)
                }
            }

            function N() {
                p(_, `is-revealing`);
                try {
                    document.activeElement === g && (_?.querySelector(`[autofocus]`) || _).focus()
                } catch {}
            }

            function ee() {
                for (let [e, t] of Object.entries({
                        ...$.Plugins,
                        ...a.plugins || {}
                    }))
                    if (e && !u[e] && t instanceof Function) {
                        let n = t();
                        n.init(Fe), u[e] = n
                    } j(`initPlugins`)
            }

            function P(e = []) {
                j(`initSlides`, e), h = [...e]
            }

            function F() {
                let e = O(`parentEl`) || document.body;
                if (!(e && e instanceof HTMLElement) || (g = i(k(O(`mainTpl`) || ``)) || void 0, !g) || (_ = g.querySelector(`.fancybox__container`), !(_ && _ instanceof HTMLElement))) return;
                let n = O(`mainClass`);
                n && f(_, n);
                let r = O(`mainStyle`);
                if (r && t(r))
                    for (let [e, t] of Object.entries(r)) _.style.setProperty(e, t);
                let a = O(`theme`),
                    c = a === `auto` ? window.matchMedia(`(prefers-color-scheme:light)`).matches : a === `light`;
                _.setAttribute(`theme`, c ? `light` : `dark`), g.setAttribute(`id`, `${l}`), g.addEventListener(`keydown`, e => {
                    e.key === `Escape` && lt(e)
                }), g.addEventListener(`wheel`, e => {
                    let t = e.target,
                        n = O(`wheel`, e);
                    t.closest(`.f-thumbs`) && (n = `slide`);
                    let r = n === `slide`,
                        i = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(function(e, t) {
                            return Math.abs(t) > Math.abs(e) ? t : e
                        }),
                        a = Math.max(-1, Math.min(1, i)),
                        s = Date.now();
                    if (D && s - D < 300) {
                        r && lt(e);
                        return
                    }
                    D = s, j(`wheel`, e, a), !e.defaultPrevented && (n === `close` ? Y(e) : n === `slide` && y && !o(t) && (lt(e), y[a > 0 ? `prev` : `next`]()))
                }, {
                    capture: !0,
                    passive: !1
                }), g.addEventListener(`cancel`, e => {
                    Y(e)
                }), e.append(g), gt.size === 1 && (O(`hideScrollbar`) && s(!0), document.documentElement.classList.add(vt)), j(`initLayout`), g instanceof HTMLDialogElement && (O(`modal`) ? g.showModal() : g.show())
            }

            function L() {
                if (v = g?.querySelector(`.fancybox__carousel`) || void 0, !v) return;
                v.fancybox = Fe;
                let e = c({}, {
                    Autoplay: {
                        autoStart: !1,
                        pauseOnHover: !1,
                        progressbarParentEl: e => {
                            let t = e.getContainer();
                            return t?.querySelector(`.f-carousel__toolbar [data-autoplay-action]`) || t
                        }
                    },
                    Fullscreen: {
                        el: _
                    },
                    Toolbar: {
                        absolute: !0,
                        items: {
                            counter: {
                                tpl: `<div class="f-counter"><span data-fancybox-page></span>/<span data-fancybox-pages></span></div>`
                            }
                        },
                        display: {
                            left: [`counter`],
                            right: [`toggleFull`, `autoplay`, `fullscreen`, `thumbs`, `close`]
                        }
                    },
                    Video: {
                        autoplay: !0
                    },
                    Thumbs: {
                        minCount: 2,
                        Carousel: {
                            classes: {
                                container: `fancybox__thumbs`
                            }
                        }
                    },
                    classes: {
                        container: `fancybox__carousel`,
                        viewport: `fancybox__viewport`,
                        slide: `fancybox__slide`
                    },
                    spinnerTpl: `<div class="f-spinner" data-fancybox-close></div>`,
                    dragFree: !1,
                    slidesPerPage: 1,
                    plugins: {
                        Sync: be,
                        Arrows: Ee,
                        Lazyload: q,
                        Zoomable: ve,
                        Html: ze,
                        Video: He,
                        Autoplay: Pe,
                        Fullscreen: Ge,
                        Thumbs: Le,
                        Toolbar: Me
                    }
                }, O(`Carousel`) || {}, {
                    slides: h,
                    enabled: !0,
                    initialPage: O(`startIndex`) || 0,
                    l10n: O(`l10n`)
                });
                y = he(v, e), j(`initCarousel`, y), y.on(`*`, (e, t, ...n) => {
                    j(`Carousel.${t}`, e, ...n)
                }), y.on(`attachSlideEl`, R), y.on(`detachSlideEl`, z), y.on(`contentLoading`, ne), y.on(`contentReady`, re), y.on(`ready`, te), y.on(`change`, V), y.on(`settle`, W), y.on(`thumbs:ready`, ie), y.on(`thumbs:destroy`, ie), y.init()
            }

            function R(e, t) {
                fe(t), ae(), t.el?.addEventListener(`click`, B), (t.type === `inline` || t.type === `clone`) && Se(t), t.type === `ajax` && Ce(t)
            }

            function z(e, t) {
                pe(t), t.el?.removeEventListener(`click`, B), (t.type === `inline` || t.type === `clone`) && we(t), t.xhr &&= (t.xhr.abort(), void 0)
            }

            function B(t) {
                if (!ge()) return;
                if (e !== Q.Ready) {
                    lt(t), t.stopPropagation();
                    return
                }
                if (t.defaultPrevented || !I.isClickAllowed()) return;
                let n = t.composedPath()[0];
                n.closest(`.fancybox__carousel`) && n.classList.contains(`fancybox__slide`) && oe(t)
            }

            function V() {
                E = !1, _ && y && _.classList.remove(`is-revealing`), ae();
                let e = O(`sync`);
                if (y && e) {
                    let t = e.getPageIndex(y.getPageIndex()) || 0;
                    e.goTo(t, {
                        transition: !1,
                        tween: !1
                    })
                }
            }

            function te() {
                de(), G(), ae(), De();
                let e = O(`sync`);
                y && e && e.getTween()?.start(), me(_e())
            }

            function W() {
                y?.canGoNext() ? De() : Ae()
            }

            function ne(e, t) {
                fe(t)
            }

            function re(e, t) {
                fe(t), me(t)
            }

            function ie() {
                let e = y?.getPlugins().Thumbs;
                m(_, `has-thumbs`, e?.isEnabled() || !1), m(_, `has-vertical-thumbs`, e ? e.getType() === `scrollable` || e.getCarousel()?.isVertical() === !0 : !1)
            }

            function G() {
                document.body.addEventListener(`click`, ue), document.body.addEventListener(`keydown`, K, {
                    passive: !1,
                    capture: !0
                })
            }

            function ae() {
                if (!_) return;
                let e = y?.getPages().length || 0,
                    t = y?.getPageIndex() || 0,
                    n = _.querySelectorAll(`[data-fancybox-index],[data-fancybox-page],[data-fancybox-pages]`);
                for (let r of n) r.hasAttribute(`data-fancybox-index`) ? r.textContent = String(t) : r.hasAttribute(`data-fancybox-page`) ? r.textContent = String(t + 1) : r.textContent = String(e)
            }

            function oe(e) {
                if (e.composedPath()[0].closest(`[data-fancybox-close]`)) {
                    Y(e);
                    return
                }
                j(`backdropClick`, e), !e.defaultPrevented && O(`backdropClick`) && Y(e)
            }

            function se() {
                ke()
            }

            function K(t) {
                if (!ge() || e !== Q.Ready) return;
                let n = t.key,
                    i = O(`keyboard`);
                if (!i || t.ctrlKey || t.altKey || t.shiftKey) return;
                let a = t.composedPath()[0];
                if (!r(a) || n !== `Escape` && (e => {
                        let t = [`input`, `textarea`, `select`, `option`, `video`, `iframe`, `[contenteditable]`, `[data-selectable]`, `[data-draggable]`].join(`,`);
                        return e.matches(t) || e.closest(t)
                    })(a) || (j(`keydown`, t), t.defaultPrevented)) return;
                let o = i[n];
                if (o) switch (o) {
                    case `close`:
                        Y(t);
                        break;
                    case `next`:
                        lt(t), y?.next();
                        break;
                    case `prev`:
                        lt(t), y?.prev();
                        break
                }
            }

            function ue(t) {
                if (!ge() || e !== Q.Ready || (ke(), t.defaultPrevented)) return;
                let n = t.composedPath()[0],
                    r = !!n.closest(`[data-fancybox-close]`),
                    i = n.classList.contains(`fancybox__backdrop`);
                (r || i) && oe(t)
            }

            function de() {
                let t = y?.getViewport();
                if (!O(`dragToClose`) || !y || !t || (b = I(t).init(), !b)) return;
                let n = !1,
                    r = 0,
                    i = 0,
                    a = {},
                    s = 1;

                function c() {
                    x?.spring({
                        clamp: !0,
                        mass: 1,
                        tension: i === 0 ? 140 : 960,
                        friction: 17,
                        restDelta: .1,
                        restSpeed: .1,
                        maxSpeed: 1 / 0
                    }).from({
                        y: r
                    }).to({
                        y: i
                    }).start();
                    let e = y?.getViewport()?.getBoundingClientRect().height || 0,
                        t = _e()?.panzoomRef;
                    if (e && t)
                        if (i === 0) t.execute(H.Reset);
                        else {
                            let n = d(Math.abs(r), 0, e * .33, s, s * .77, !1);
                            t.execute(H.ZoomTo, {
                                scale: n
                            })
                        }
                }
                let l = e => {
                    let t = e.srcEvent,
                        n = t.target;
                    return y && !(T(t) && t.touches?.length > 1) && n && !o(n)
                };
                x = w().on(`step`, n => {
                    if (_ && t && e === Q.Ready) {
                        let e = t.getBoundingClientRect().height;
                        r = Math.min(e, Math.max(e * -1, n.y));
                        let i = d(Math.abs(r), 0, e * .65, 1, .2, !0);
                        _.style.setProperty(`--f-drag-opacity`, i + ``), _.style.setProperty(`--f-drag-offset`, r + `px`)
                    }
                }), b.on(`start`, function() {
                    n || (x?.pause(), i = r)
                }).on(`panstart`, e => {
                    if (!n && l(e) && e.axis === `y`) {
                        lt(e.srcEvent), n = !0, J(), y?.getViewport()?.classList.add(`is-dragging`);
                        let t = _e()?.panzoomRef;
                        if (t) {
                            s = t.getTransform().scale || 1;
                            let e = t.getOptions();
                            a = {
                                ...e
                            }, e.bounds = !1, e.gestures = !1
                        }
                    } else n = !1
                }).on(`pan`, function(e) {
                    n && l(e) && (lt(e.srcEvent), e.srcEvent.stopPropagation(), e.axis === `y` && (i += e.deltaY, c()))
                }).on(`end`, t => {
                    if (y?.getViewport()?.classList.remove(`is-dragging`), n) {
                        let e = _e()?.panzoomRef;
                        if (e) {
                            e.getTween()?.end();
                            let t = e.getOptions();
                            t.bounds = a.bounds || !1, t.gestures = a.gestures || !1
                        }
                        l(t) && t.axis === `y` && (Math.abs(t.velocityY) > 5 || Math.abs(r) > 50) && Y(t.srcEvent, `f-throwOut` + (t.velocityY > 0 ? `Down` : `Up`))
                    }
                    n = !1, e === Q.Ready && r !== 0 && (i = 0, c())
                })
            }

            function fe(e) {
                let {
                    el: t,
                    htmlEl: n,
                    panzoomRef: r,
                    closeButtonEl: a
                } = e, o = r ? r.getWrapper() : n;
                if (!t || !t.parentElement || !o) return;
                let s = O(`closeButton`);
                if (s === `auto` && (s = y?.getPlugins().Toolbar?.isEnabled() !== !0), !s) {
                    pe(e);
                    return
                }
                if (!a) {
                    let n = i(k(O(`closeButtonTpl`)));
                    n && (f(n, `is-close-button`), e.closeButtonEl = o.insertAdjacentElement(`afterbegin`, n), f(t, `has-close-btn`))
                }
            }

            function pe(e) {
                e.closeButtonEl &&= (e.closeButtonEl.remove(), void 0), p(e.el, `has-close-btn`)
            }

            function me(e) {
                if (!(E && y && y.getState() === ce.Ready && e && e.index === y.getOptions().initialPage && e.el && e.el.parentElement) || e.state !== void 0 && e.state !== le.Loaded) return;
                E = !1;
                let t = e.panzoomRef,
                    n = t?.getTween(),
                    r = O(`zoomEffect`) && n ? xe(e) : void 0;
                if (t && n && r) {
                    let {
                        x: e,
                        y: i,
                        scale: a
                    } = t.getStartPosition();
                    n.spring({
                        tension: 215,
                        friction: 25,
                        restDelta: .001,
                        restSpeed: .001,
                        maxSpeed: 1 / 0
                    }).from(r).to({
                        x: e,
                        y: i,
                        scale: a
                    }).start();
                    return
                }
                let i = t?.getContent() || e.htmlEl;
                i && pt(i, O(`showClass`, e))
            }

            function ge() {
                return $.getInstance()?.getId() === l
            }

            function _e() {
                return y?.getPage()?.slides[0]
            }

            function ye() {
                let e = _e();
                return e ? e.triggerEl || O(`triggerEl`) : void 0
            }

            function xe(e) {
                let t = e.thumbEl;
                if (!t || !ut(t)) return;
                let n = e.panzoomRef?.getWrapper()?.getBoundingClientRect(),
                    r = n?.width,
                    i = n?.height;
                if (!r || !i) return;
                let a = t.getBoundingClientRect(),
                    o = a.width,
                    s = a.height,
                    c = a.left,
                    l = a.top;
                if (!(!a || !o || !s)) {
                    if (t instanceof HTMLImageElement) {
                        let e = window.getComputedStyle(t).getPropertyValue(`object-fit`);
                        if (e === `contain` || e === `scale-down`) {
                            let {
                                width: n,
                                height: r
                            } = ft(t.naturalWidth, t.naturalHeight, o, s, e);
                            c += (o - n) * .5, l += (s - r) * .5, o = n, s = r
                        }
                    }
                    if (!(Math.abs(r / i - o / s) > .1)) return {
                        x: c + o * .5 - (n.left + r * .5),
                        y: l + s * .5 - (n.top + i * .5),
                        scale: o / r
                    }
                }
            }

            function Se(e) {
                if (!y || !e || !e.el) return;
                let t = null;
                if (n(e.src)) {
                    let n = e.src.split(`#`, 2).pop();
                    t = n ? document.getElementById(n) : null
                }
                if (t) {
                    if (f(t, `f-html`), e.type === `clone` || t.closest(`.fancybox__carousel`)) {
                        t = t.cloneNode(!0);
                        let n = t.dataset.animationName;
                        n && (t.classList.remove(n), delete t.dataset.animationName);
                        let r = t.getAttribute(`id`);
                        r = r ? `${r}--clone` : `clone-${l}-${e.index}`, t.setAttribute(`id`, r)
                    } else if (t.parentNode) {
                        let n = document.createElement(`div`);
                        n.inert = !0, t.parentNode.insertBefore(n, t), e.placeholderEl = n
                    }
                    e.htmlEl = t, f(e.el, `has-html`), e.el.prepend(t), t.classList.remove(`hidden`), t.style.display === `none` && (t.style.display = ``), getComputedStyle(t).getPropertyValue(`display`) === `none` && (t.style.display = t.dataset.display || `flex`), y?.emit(`contentReady`, e)
                } else y?.showError(e, `{{ELEMENT_NOT_FOUND}}`)
            }

            function Ce(t) {
                let n = t.el;
                if (!n || t.htmlEl || t.xhr) return;
                y?.showLoading(t), t.state = le.Loading;
                let r = new XMLHttpRequest;
                r.onreadystatechange = function() {
                    if (r.readyState === XMLHttpRequest.DONE && e === Q.Ready)
                        if (y?.hideLoading(t), t.state = le.Loaded, r.status === 200) {
                            let e = r.responseText + ``,
                                i = null,
                                a = null;
                            if (t.filter) {
                                let n = document.createElement(`div`);
                                n.innerHTML = e, a = n.querySelector(t.filter + ``)
                            }
                            a && a instanceof HTMLElement ? i = a : (i = document.createElement(`div`), i.innerHTML = e), i.classList.add(`f-html`), t.htmlEl = i, n.classList.add(`has-html`), n.classList.add(`has-ajax`), n.prepend(i), y?.emit(`contentReady`, t)
                        } else y?.showError(t)
                };
                let i = O(`ajax`) || null;
                r.open(i ? `POST` : `GET`, t.src + ``), r.setRequestHeader(`Content-Type`, `application/x-www-form-urlencoded`), r.setRequestHeader(`X-Requested-With`, `XMLHttpRequest`), r.send(i), t.xhr = r
            }

            function we(e) {
                let t = e.htmlEl,
                    n = e.placeholderEl;
                t && (getComputedStyle(t).getPropertyValue(`display`) !== `none` && (t.style.display = `none`), t.offsetHeight), n && (t && n.parentNode && n.parentNode.insertBefore(t, n), n.remove()), e.htmlEl = void 0, e.placeholderEl = void 0
            }

            function Te() {
                S && clearTimeout(S), S = void 0, document.removeEventListener(`mousemove`, se)
            }

            function De() {
                if (C || S) return;
                let e = O(`idle`);
                e && (S = setTimeout(Oe, e))
            }

            function Oe() {
                _ && (Te(), f(_, `is-idle`), document.addEventListener(`mousemove`, se), C = !0)
            }

            function ke() {
                C && (Ae(), De())
            }

            function Ae() {
                Te(), _?.classList.remove(`is-idle`), C = !1
            }

            function J() {
                let e = ye();
                e && !dt(e) && !e.closest(`[inert]`) && e.scrollIntoView({
                    behavior: `instant`,
                    block: `center`,
                    inline: `center`
                })
            }

            function Y(t, n) {
                if (e === Q.Closing || e === Q.Destroyed) return;
                let r = new Event(`shouldClose`, {
                    bubbles: !0,
                    cancelable: !0
                });
                if (j(`shouldClose`, r, t), r.defaultPrevented) return;
                if (Te(), t) {
                    if (t.defaultPrevented) return;
                    lt(t), t.stopPropagation(), t.stopImmediatePropagation()
                }
                if (e = Q.Closing, x?.pause(), b?.destroy(), y) {
                    y.getGestures()?.destroy(), y.getTween()?.pause();
                    for (let e of y.getSlides()) {
                        let t = e.panzoomRef;
                        t && (c(t.getOptions(), {
                            clickAction: !1,
                            dblClickAction: !1,
                            wheelAction: !1,
                            bounds: !1,
                            minScale: 0,
                            maxScale: 1 / 0
                        }), t.getGestures()?.destroy(), t.getTween()?.pause())
                    }
                }
                let i = y?.getPlugins();
                i?.Autoplay?.stop();
                let a = i?.Fullscreen;
                a && a.inFullscreen() ? Promise.resolve(a.exit()).then(() => {
                    setTimeout(() => {
                        je(t, n)
                    }, 150)
                }) : je(t, n)
            }

            function je(t, n) {
                if (e !== Q.Closing) return;
                j(`close`, t), E = !1, document.body.removeEventListener(`click`, ue), document.body.removeEventListener(`keydown`, K, {
                    passive: !1,
                    capture: !0
                }), O(`placeFocusBack`) && J();
                let r = document.activeElement;
                r && g?.contains(r) && r.blur(), O(`fadeEffect`) && (_?.classList.remove(`is-ready`), _?.classList.add(`is-hiding`)), _?.classList.add(`is-closing`);
                let i = _e(),
                    a = i?.el,
                    o = i?.panzoomRef,
                    s = i?.panzoomRef?.getTween(),
                    c = n || O(`hideClass`),
                    l = !1,
                    u = !1;
                if (y && i && a && o && s) {
                    let e;
                    if (O(`zoomEffect`) && i.state === le.Loaded && (e = xe(i)), e) {
                        l = !0;
                        let t = () => {
                            e = xe(i), e ? s.to({
                                ...U,
                                ...e
                            }) : Ne()
                        };
                        o.on(`refresh`, () => {
                            t()
                        }), s.easing(w.Easings.EaseOut).duration(350).from({
                            ...o.getTransform()
                        }).to({
                            ...U,
                            ...e
                        }).start(), a?.getAnimations() && (a.style.animationPlayState = `paused`, requestAnimationFrame(() => {
                            t()
                        }))
                    }
                }
                let d = i?.htmlEl || i?.panzoomRef?.getWrapper();
                d && mt(d), !l && c && d && (u = !0, pt(d, c, () => {
                    Ne()
                })), l || u ? setTimeout(() => {
                    Ne()
                }, 350) : Ne()
            }

            function Ne() {
                if (e === Q.Destroyed) return;
                e = Q.Destroyed;
                let t = ye();
                j(`destroy`), O(`sync`)?.getPlugins().Autoplay?.resume(), O(`sync`)?.getPlugins().Autoscroll?.resume(), g instanceof HTMLDialogElement && g.close(), y?.getContainer()?.classList.remove(`is-idle`), y?.destroy();
                for (let e of Object.values(u)) e?.destroy();
                if (u = {}, g?.remove(), g = void 0, _ = void 0, y = void 0, gt.delete(l), !gt.size && (s(!1), document.documentElement.classList.remove(vt), O(`placeFocusBack`) && t && !t.closest(`[inert]`))) try {
                    t?.focus({
                        preventScroll: !0
                    })
                } catch {}
            }
            let Fe = {
                close: Y,
                destroy: Ne,
                getCarousel: function() {
                    return y
                },
                getContainer: function() {
                    return _
                },
                getId: function() {
                    return l
                },
                getOptions: function() {
                    return a
                },
                getPlugins: function() {
                    return u
                },
                getSlide: function() {
                    return _e()
                },
                getState: function() {
                    return e
                },
                init: M,
                isCurrentSlide: function(e) {
                    let t = _e();
                    return !e || !t ? !1 : t.index === e.index
                },
                isTopMost: function() {
                    return ge()
                },
                localize: k,
                off: function(e, t) {
                    return A.has(e) && A.set(e, A.get(e).filter(e => e !== t)), Fe
                },
                on: function(e, t) {
                    return A.set(e, [...A.get(e) || [], t]), Fe
                },
                toggleIdle(e) {
                    (C || e === !0) && Oe(), (!C || e === !1) && Ae()
                }
            };
            return Fe
        };

    function bt() {
        for (let e of Object.values($.Plugins)) {
            let t = e.setup;
            typeof t == `function` && t($)
        }
    }

    function xt(e, t, n, r = {}) {
        if (!(e && e instanceof Element) || !n) return;
        let i = $.openers.get(e) || new Map,
            a = i.get(t) || new Map;
        a.set(n, r), i.set(t, a), $.openers.set(e, i), i.size === 1 && e.addEventListener(`click`, $.fromEvent), bt()
    }

    function St(e, t, n) {
        if (!(e && e instanceof Element) || !n) return;
        let r = $.openers.get(e) || new Map,
            i = r.get(t) || new Map;
        i && n && i.delete(n), (!i.size || !n) && r.delete(t), r.size || ($.openers.delete(e), e.removeEventListener(`click`, $.fromEvent))
    }

    function Ct(e, t, r, i) {
        if (!l()) return;
        let a = document.body,
            o = null,
            s = `[data-fancybox]`,
            c = {};
        e instanceof Element && (a = e), n(e) && n(t) ? (o = e, s = t) : n(t) && n(r) ? (o = t, s = r) : n(t) ? s = t : n(e) && (s = e), typeof t == `object` && (c = t || {}), typeof r == `object` && (c = r || {}), typeof i == `object` && (c = i || {}), xt(a, o, s, c)
    }

    function wt(e, t, r) {
        if (!l()) return;
        let i = document.body,
            a = null,
            o = `[data-fancybox]`;
        e instanceof Element && (i = e), n(e) && n(t) ? (a = e, o = t) : n(t) && n(r) ? (a = t, o = r) : n(t) ? o = t : n(e) && (o = e), St(i, a, o)
    }

    function Tt(e, t, r, i) {
        if (!l()) return;
        let a = document.body,
            o = null,
            s = `[data-fancybox]`,
            c = {};
        e instanceof Element && (a = e), n(e) && n(t) ? (o = e, s = t) : n(t) && n(r) ? (o = t, s = r) : n(t) ? s = t : n(e) && (s = e), typeof t == `object` && (c = t || {}), typeof r == `object` && (c = r || {}), typeof i == `object` && (c = i || {});
        for (let [e, t] of $.openers)
            for (let [n, r] of t)
                for (let [t, i] of r)
                    if (e === a && n === o) {
                        let e = a.querySelector((n ? `${n} ` : ``) + s);
                        if (e && e.matches(t)) return $.fromTriggerEl(e, c)
                    }
    }

    function Et(e) {
        if (e.defaultPrevented || e.button && e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) return;
        let t = e.composedPath()[0],
            n = {
                triggerEvent: e
            };
        if (t.closest(`.fancybox__container.is-hiding`)) {
            lt(e), e.stopPropagation();
            return
        }
        let r = t.closest(`[data-fancybox-delegate]`) || void 0;
        if (r) {
            let e = r.dataset.fancyboxDelegate || ``,
                i = document.querySelectorAll(`[data-fancybox="${e}"]`),
                a = parseInt(r.dataset.fancyboxIndex || ``, 10) || 0;
            t = i[a] || i[0], c(n, {
                delegateEl: r,
                startIndex: a
            })
        }
        return Dt(t, n)
    }

    function Dt(e, t = {}) {
        if (!(e && e instanceof Element)) return;
        let n, r, i, a, o = {};
        for (let [t, s] of $.openers)
            if (t.contains(e))
                for (let [l, u] of s) {
                    let s;
                    if (l) {
                        for (let n of t.querySelectorAll(l))
                            if (n.contains(e)) {
                                s = n;
                                break
                            } if (!s) continue
                    }
                    for (let [l, d] of u) {
                        let u = null;
                        try {
                            u = e.closest(l)
                        } catch {}
                        u && (r = t, i = s, n = u, a = l, c(o, d || {}))
                    }
                }
        if (!r || !a || !n) return;
        let s = c({}, ht, t, o, {
                triggerEl: n
            }),
            l = [].slice.call((i || r).querySelectorAll(a)),
            u = n.closest(`.f-carousel`),
            d = u?.carousel;
        if (d && !(i && u.contains(i))) {
            let e = [];
            for (let t of d?.getSlides()) {
                let n = t.el;
                n && (n.matches(a) ? e.push(n) : e.push(...[].slice.call(n.querySelectorAll(a))))
            }
            e.length && (l = [...e], d.getPlugins().Autoplay?.pause(), d.getPlugins().Autoscroll?.pause(), s.sync = d)
        }
        if (s.groupAll === !1) {
            let e = s.groupAttr,
                t = e && n ? n.getAttribute(`${e}`) : ``;
            l = e && t && t !== `true` ? l.filter(n => n.getAttribute(`${e}`) === t) : [n]
        }
        if (!l.length) return;
        s.triggerEvent?.preventDefault();
        let f = $.getInstance(),
            p = f?.getState();
        if (f && (p === Q.Init || p === Q.Ready)) {
            let e = f.getOptions().triggerEl;
            if (e && l.indexOf(e) > -1) return
        }
        return {
            ...s.Carousel || {}
        }.rtl && (l = l.reverse()), n && t.startIndex === void 0 && (s.startIndex = l.indexOf(n)), $.fromNodes(l, s)
    }

    function Ot(e, t) {
        t = c({}, ht, t || {});
        let n = [],
            r = e => e instanceof HTMLImageElement ? e : e instanceof HTMLElement ? e.querySelector(`img:not([aria-hidden])`) : void 0;
        for (let i of e) {
            let a = i.dataset || {},
                o = t.delegateEl && e.indexOf(i) === t.startIndex ? t.delegateEl : void 0,
                s = r(o) || r(i) || void 0,
                c = a.src || i.getAttribute(`href`) || i.getAttribute(`currentSrc`) || i.getAttribute(`src`) || void 0,
                l = a.thumb || a.thumbSrc || s?.getAttribute(`currentSrc`) || s?.getAttribute(`src`) || s?.dataset.lazySrc || void 0,
                u = {
                    src: c,
                    alt: a.alt || s?.getAttribute(`alt`) || void 0,
                    thumbSrc: l,
                    thumbEl: s,
                    triggerEl: i,
                    delegateEl: o
                };
            for (let e in a) {
                let t = a[e] + ``;
                u[e] = t === `true` ? e === `fancybox` ? `` : !0 : t === `false` ? !1 : t
            }
            n.push(u)
        }
        return $.show(n, t)
    }
    let $ = {
        Plugins: {
            Hash: st
        },
        version: `6.1.14`,
        openers: new Map,
        bind: Ct,
        close: function(e = !0, ...t) {
            if (e)
                for (let e of gt.values()) e.close(...t);
            else {
                let e = $.getInstance();
                e && e.close(...t)
            }
        },
        destroy: function() {
            let e;
            for (; e = $.getInstance();) e.destroy();
            for (let e of $.openers.keys()) e.removeEventListener(`click`, $.fromEvent);
            $.openers.clear()
        },
        fromEvent: Et,
        fromNodes: Ot,
        fromSelector: Tt,
        fromTriggerEl: Dt,
        getCarousel: function() {
            return $.getInstance()?.getCarousel() || void 0
        },
        getDefaults: function() {
            return ht
        },
        getInstance: function(e) {
            if (e) {
                let t = gt.get(e);
                return t && t.getState() !== Q.Destroyed ? t : void 0
            }
            return Array.from(gt.values()).reverse().find(e => {
                if (e.getState() !== Q.Destroyed) return e
            }) || void 0
        },
        getSlide: function() {
            return $.getInstance()?.getSlide() || void 0
        },
        show: function(e = [], t = {}) {
            return bt(), yt().init(e, t)
        },
        unbind: wt
    };
    e.Arrows = Ee, e.Autoplay = Pe, e.Carousel = he, e.CarouselSlideContentState = le, e.CarouselState = ce, e.Fancybox = $, e.FancyboxState = Q, e.Fullscreen = Ge, e.Html = ze, e.Lazyload = q, e.PANZOOM_DEFAULT_POS = U, e.Panzoom = oe, e.PanzoomAction = H, e.PanzoomState = W, e.PanzoomZoomLevel = te, e.Sync = be, e.Thumbs = Le, e.Toolbar = Me, e.ToolbarColumn = J, e.Video = He, e.Zoomable = ve
});